module.exports.wheels = [
  {
    name: "Starter",
    headCol: "#b2f252",
    price: 50,
    icons: 2,
    rarities: [75, 22, 3, 0, 0, 0],
    getRarities: function () {
      return this.rarities;
    },
  },
  {
    name: "Elite",
    headCol: "#2196F3",
    price: 100,
    icons: 3,
    rarities: [50, 30, 15, 5, 0, 0],
    getRarities: function () {
      return this.rarities;
    },
  },
  {
    name: "Heroic",
    headCol: "#fc9803",
    price: 500,
    icons: 5,
    rarities: [0, 48, 35, 14, 2.5, 0.5],
    getRarities: function () {
      return this.rarities;
    },
  },
  {
    name: "Valour",
    locked: true,
    icons: 1,
    rarities: [43, 33, 16, 6, 2, 0],
    getRarities: function () {
      return this.rarities;
    },
  },
  {
    name: "Free",
    free: true,
    hideMobile: true,
    openURL: true,
    minLvl: 5,
    price: 0,
    priceT: "Follow",
    priceCol: "#00eaff",
    icons: 2,
    rarities: [0, 48, 35, 14, 3, 0],
    getRarities: function () {
      return this.rarities;
    },
  },
  {
    name: "Free KR",
    free: true,
    kr: true,
    hideMobile: true,
    minLvl: 1,
    price: 0,
    priceCol: "#00eaff",
    adjRars: true,
    rarities: [51, 19, 15, 8, 5, 1.9, 0.1],
    getRarities: function () {
      return this.rarities;
    },
  },
  {
    name: "Twitch",
    price: 0,
    hideMobile: true,
    priceT: "Redeem",
    priceCol: "#00eaff",
    limType: "Charity",
    twitch: true,
    icons: 0,
    getRarities: function () {
      return [0, 0, 50, 35, 15, 0];
    },
  },
];
module.exports.events = {
  Debug: "#000000",
  Easter: null,
  "Twitch #1": "#6441a5",
  "Twitch #2": "#6441a5",
  "Twitch #3": "#6441a5",
  "Clan Wars": null,
  Charity: "#6441a5",
  Raid: "#eb347a",
};
module.exports.types = [
  "weapons/weapon_",
  "hats/hat_",
  "body/body_",
  "melee/melee_",
  "sprays/",
  "dyes/",
  "waist/waist_",
  "faces/face_",
];
module.exports.purchases = [
  {
    val: 300,
    price: 0.99,
  },
  {
    val: 600,
    price: 1.79,
  },
  {
    val: 2600,
    price: 7.49,
  },
  {
    val: 7000,
    price: 15.99,
  },
  {
    val: 20000,
    price: 34.99,
    tag: "Popular!",
    tagCol: "#ed4242",
  },
  {
    val: 60000,
    tag: "Best Value!",
    tagCol: "#E040FB",
    price: 99.99,
  },
];
module.exports.mobilePurchases = [
  {
    val: 300,
    price: 0.99,
    productId: "ch.yendis.krunkerhub.kr300",
  },
  {
    val: 600,
    price: 1.79,
    productId: "ch.yendis.krunkerhub.kr600",
  },
  {
    val: 2600,
    price: 7.49,
    productId: "ch.yendis.krunkerhub.kr2600",
  },
  {
    val: 7000,
    price: 15.99,
    productId: "ch.yendis.krunkerhub.kr7000",
  },
  {
    val: 20000,
    price: 34.99,
    productId: "ch.yendis.krunkerhub.kr20000",
    tag: "Popular!",
    tagCol: "#ed4242",
  },
  {
    val: 60000,
    price: 99.99,
    productId: "ch.yendis.krunkerhub.kr60000",
    tag: "Best Value!",
    tagCol: "#E040FB",
  },
];
module.exports.premium = [
  {
    val: 30,
    price: 7500,
    tag: "Popular!",
    tagCol: "#ed4242",
    headCol: "#2196F3",
  },
  {
    val: 60,
    price: 14000,
    headCol: "#E040FB",
  },
  {
    val: 90,
    price: 19000,
    tag: "Best Value!",
    tagCol: "#E040FB",
    headCol: "#fc9803",
  },
];
module.exports.lootRars = [0, 0, 64, 30.5, 5, 0.5, 0];
module.exports.rarities = [
  {
    name: "Uncommon",
    rar: 60,
    color: "#b2f252",
    confC: 30,
    confCols: ["#b2f252", "#fff"],
    sell: 1,
    fee: 5,
  },
  {
    name: "Rare",
    rar: 40,
    color: "#2196F3",
    confC: 30,
    confCols: ["#2196F3", "#fff"],
    sell: 3,
    fee: 5,
  },
  {
    name: "Epic",
    rar: 25,
    color: "#E040FB",
    confC: 30,
    confCols: ["#E040FB", "#fff"],
    sell: 10,
    fee: 5,
  },
  {
    name: "Legendary",
    rar: 10,
    color: "#FBC02D",
    confC: 40,
    confCols: ["#FBC02D", "#fff"],
    sell: 100,
    fee: 10,
  },
  {
    name: "Relic",
    rar: 2.5,
    color: "#ed4242",
    confC: 50,
    confCols: ["#ed4242", "#fff"],
    sell: 500,
    fee: 10,
  },
  {
    name: "Contraband",
    rar: 0.5,
    color: "#292929",
    confC: 70,
    confCols: ["#292929", "#fff"],
    sell: 2500,
    fee: 25,
  },
  {
    name: "Unobtainable",
    rar: 0,
    color: "#fff53d",
    confC: 100,
    confCols: [
      "#ff0000",
      "#ffa500",
      "#ffff00",
      "#008000",
      "#0000ff",
      "#4b0082",
      "#ee82ee",
    ],
    animate: true,
    sell: 10000,
    fee: 200,
  },
];
module.exports.getSpnItems = function (d, f, g, h) {
  f = f || 0;
  var j = [];
  var k = d.itemTypes;
  var m = d.limType;
  var p = d.weaponType;
  for (var q = 0; q < module.exports.skins.length; ++q) {
    if (
      !!module.exports.skins[q] &&
      !module.exports.skins[q].limited &&
      !module.exports.skins[q].blocked &&
      !module.exports.skins[q].noSpin &&
      !module.exports.skins[q].illicit &&
      module.exports.skins[q].rarity == f &&
      (!m || m == module.exports.skins[q].limT) &&
      (!!m || !module.exports.skins[q].limT) &&
      (!k || !(k.indexOf(module.exports.skins[q].type || 0) < 0)) &&
      (!module.exports.skins[q].minRec ||
        (!!module.exports.skins[q].minRec &&
          !!g &&
          !!(g.level < module.exports.skins[q].minRec))) &&
      (module.exports.skins[q].seas || 1) == h.currentSeason &&
      (p == null || p == module.exports.skins[q].weapon)
    ) {
      j.push(q);
    }
  }
  return j;
};
module.exports.calcTradeFee = function (d) {
  var f;
  var g = 0;
  for (var h = 0; h < d.length; ++h) {
    if ((f = module.exports.skins[d[h]])) {
      g += module.exports.rarities[f.rarity].fee || 0;
    }
  }
  return g;
};
module.exports.getFreeKR = function (d, f) {
  var g = 0;
  if (f.level >= 20) {
    g = 1;
  }
  return {
    kr: module.exports.freeKR[d].kr[g],
    rarity: module.exports.freeKR[d].rarity,
  };
};
module.exports.freeKR = [
  {
    kr: [15, 35],
    rarity: 0,
  },
  {
    kr: [25, 60],
    rarity: 1,
  },
  {
    kr: [40, 120],
    rarity: 2,
  },
  {
    kr: [100, 200],
    rarity: 3,
  },
  {
    kr: [160, 450],
    rarity: 4,
  },
  {
    kr: [1000, 2000],
    rarity: 5,
  },
  {
    kr: [4000, 10000],
    rarity: 6,
  },
];
module.exports.previews = {
  1: {
    xOff: -2,
    yOff: -2.6,
    zRota: 0.2,
    scl: 0.001376794727638135,
  },
  2: {
    xOff: -1.4,
    yOff: -0.8,
    scl: 0.001148941748743716,
  },
  3: {
    xOff: 0,
    yOff: -0.2,
    scl: 0.000676917226130652,
  },
  4: {
    xOff: -1.5,
    yOff: 0.5,
    scl: 0.000940741507537686,
  },
  5: {
    xOff: -0.8,
    yOff: 0.5,
    scl: 0.00079312502512562,
  },
  6: {
    xOff: -1,
    yOff: -1.1,
    scl: 1.2,
  },
  7: {
    xOff: -1,
    yOff: -0.9,
    scl: 0.001221518472361808,
  },
  8: {
    xOff: -1,
    yOff: -0.6,
    scl: 0.0012179208743718641,
  },
  9: {
    xOff: -1.2,
    yOff: -1,
    scl: 0.0010676876984924638,
  },
  10: {
    scl: 1.6,
  },
  14: {
    yOff: -2.5,
    scl: 0.0007874150753768881,
  },
  15: {
    scl: 0.00098426884422111,
  },
  16: {
    scl: 1.4,
    yOff: 1,
    xOff: -1,
  },
  17: {
    xOff: 0,
    yOff: -0.2,
    scl: 0.0003,
  },
  19: {
    xOff: -1.4,
    yOff: -0.8,
    scl: 0.0009095788844221084,
  },
};
module.exports.skins = [
  {
    name: "Arctic Hunt",
    id: 0,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Autumn Hunt",
    id: 1,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Reticle Blaze",
    id: 2,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Digital Hunt",
    id: 3,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Moon Dragon",
    id: 4,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "ScharfschÃ¼tze",
    id: 5,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Woodland Sniper",
    id: 6,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Hazard Reticle",
    id: 7,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Kodac Reticle",
    id: 8,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Seafarer",
    id: 9,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Acid Breath",
    glow: true,
    id: 10,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Trail Scout",
    id: 11,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Arctic AK",
    id: 0,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Autumn AK",
    id: 1,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Blaze AK",
    id: 2,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Digital AK",
    id: 3,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Luna Dragon",
    id: 4,
    weapon: 2,
    rarity: 3,
  },
  {
    name: "Flecken AK",
    id: 5,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Woodland AK",
    id: 6,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Hazard AK",
    id: 7,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Kodac AK",
    id: 8,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Seafarer AK",
    id: 9,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Trail AK",
    id: 10,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "SMG Arctic",
    id: 0,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "SMG Autumn",
    id: 1,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "SMG Blaze",
    id: 2,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "SMG Digital",
    id: 3,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Flecken",
    id: 4,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "SMG Woodland",
    id: 5,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Hazard",
    id: 6,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "SMG Kodac",
    id: 7,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "SMG Seafarer",
    id: 8,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Trail",
    id: 9,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Arctic Python",
    id: 0,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "Autumn Python",
    id: 1,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "Blaze Python",
    id: 2,
    weapon: 5,
    rarity: 2,
  },
  {
    name: "Digital Python",
    id: 3,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Flecken Python",
    id: 4,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "Woodland",
    id: 5,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Hazard Python",
    id: 6,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "Kodac Python",
    id: 7,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "Seafarer",
    id: 8,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Trail Python",
    id: 9,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Arctic Slug",
    id: 0,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Autumn Slug",
    id: 1,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Twin Blaze",
    id: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "SG Digital",
    id: 3,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Flecken",
    id: 4,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Woodland",
    id: 5,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Hazard Slug",
    id: 6,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Kodac Slug",
    id: 7,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Buccaneer",
    id: 8,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "SG Trail",
    id: 9,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Arctic LMG",
    id: 0,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Autumn LMG",
    id: 1,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Blaze LMG",
    id: 2,
    weapon: 7,
    rarity: 2,
  },
  {
    name: "Digital LMG",
    id: 3,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Flecken LMG",
    id: 4,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Woodland LMG",
    id: 5,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Hazard LMG",
    id: 6,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Kodac LMG",
    id: 7,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Seafarer LMG",
    id: 8,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Trail LMG",
    id: 9,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Arctic Auto",
    id: 0,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Autumn Auto",
    id: 1,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Blaze Auto",
    id: 2,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "Digital Auto",
    id: 3,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Flecken Auto",
    id: 4,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Woodland Auto",
    id: 5,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Hazard Auto",
    id: 6,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Kodac Auto",
    id: 7,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Seafarer Auto",
    id: 8,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Trail Auto",
    id: 9,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Mach Auto",
    id: 10,
    creator: "AtarSt",
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Arctic RL",
    id: 0,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Autumn RL",
    id: 1,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Blaze RL",
    id: 2,
    weapon: 9,
    rarity: 2,
  },
  {
    name: "Digital RL",
    id: 3,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Flecken RL",
    id: 4,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Woodland RL",
    id: 5,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Hazard RL",
    id: 6,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Kodac RL",
    id: 7,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Seafarer RL",
    id: 8,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Trail RL",
    id: 9,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "101 Skullbreaker",
    id: 12,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Reticle Faded",
    id: 13,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Puma Sniper",
    id: 14,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Scoped Elite",
    id: 15,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Faded AK",
    id: 11,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Puma AR",
    id: 12,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "SMG Fade",
    id: 10,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Puma",
    id: 11,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "Faded Python",
    id: 10,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Puma Python",
    id: 11,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "SG Fade",
    id: 10,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Slug Puma",
    id: 11,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Faded LMG",
    id: 10,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Puma LMG",
    id: 11,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Faded MMR",
    id: 11,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Puma MMR",
    id: 12,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Faded RTL",
    id: 10,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Puma RTL",
    id: 11,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Scoped Carbon",
    id: 16,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Carbon AK",
    id: 13,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "SMG Carbon",
    id: 12,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Carbon Python",
    id: 12,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "SG Carbon",
    id: 12,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Carbon LMG",
    id: 12,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Carbon MMR",
    id: 13,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Carbon RTL",
    id: 12,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Neon Ripper",
    id: 14,
    glow: true,
    weapon: 2,
    rarity: 4,
  },
  {
    name: "Top Hat",
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sitOff: 0.4,
    yOff: -4,
    id: 1,
    rarity: 2,
  },
  {
    name: "SMG Spitfire",
    id: 13,
    weapon: 4,
    rarity: 3,
  },
  {
    name: "Cowboy Hat",
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sitOff: 0.4,
    yOff: -3,
    id: 0,
    rarity: 0,
  },
  {
    name: "Flame Tamer",
    id: 13,
    pulsT: 0.0015,
    weapon: 5,
    glow: true,
    rarity: 5,
  },
  {
    name: "Cool Cap",
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sitOff: 0.4,
    yOff: -3,
    xOff: 2,
    id: 2,
    rarity: 1,
  },
  {
    name: "Jack O' Lantern",
    type: 1,
    keyW: "Head",
    scl: 2.8,
    glow: true,
    sclMlt: 1.4,
    sitOff: 2.05,
    yOff: -4,
    id: 3,
    rarity: 3,
  },
  {
    name: "Medic Helmet",
    type: 1,
    keyW: "Head",
    scl: 2.8,
    sclMlt: 1,
    sitOff: 0.65,
    yOff: -2.5,
    id: 4,
    rarity: 2,
  },
  {
    name: "Neon Reaver",
    creator: "Electrode_",
    id: 17,
    glow: true,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Sun Glasses",
    type: 1,
    keyW: "Head",
    scl: 2.8,
    sclMlt: 1,
    sitOff: 2.3,
    yOff: -5,
    xOff: 2,
    id: 5,
    rarity: 0,
  },
  {
    name: "Afro",
    type: 1,
    keyW: "Head",
    scl: 2,
    sclMlt: 0.9,
    sitOff: 1.4,
    yOff: -4,
    id: 6,
    rarity: 0,
  },
  {
    name: "Hard Hat",
    type: 1,
    keyW: "Head",
    scl: 3,
    sitOff: 0.4,
    yOff: -3,
    id: 7,
    rarity: 0,
  },
  {
    name: "Zombie Head",
    type: 1,
    keyW: "Head",
    scl: 2.8,
    glow: true,
    sclMlt: 1.2,
    sitOff: 2.05,
    yOff: -4,
    id: 8,
    rarity: 3,
  },
  {
    name: "Barbed Rifle",
    id: 18,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Blushed Sniper",
    id: 19,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "AWP Mech",
    id: 20,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Olympus Rifle",
    id: 21,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Scoped Tuscan",
    id: 22,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "AWP Pacemaker",
    id: 23,
    weapon: 1,
    rarity: 4,
    glow: true,
  },
  {
    name: "AR Wired",
    id: 15,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Blushed AK",
    id: 16,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Mach Rifle",
    id: 17,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Olympus Rifle",
    id: 18,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "AR Tuscan",
    id: 19,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "SMG Barbed",
    id: 14,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "SMG Blossom",
    id: 15,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Machinist",
    id: 16,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "SMG Lazarus",
    id: 17,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "SMG Tuscan",
    id: 18,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "Barbed Python",
    id: 14,
    weapon: 5,
    rarity: 2,
  },
  {
    name: "Blushed Revolver",
    id: 15,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Machinist Python",
    id: 16,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "REV Olympus",
    id: 17,
    weapon: 5,
    rarity: 2,
  },
  {
    name: "Tuscan Revolver",
    id: 18,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "Coach Barb",
    id: 13,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Blossom",
    id: 14,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "MD Frag",
    id: 15,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "SG Olympus",
    id: 16,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "SG Tuscan",
    id: 17,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Blushed LMG",
    id: 13,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Machinist LMG",
    id: 14,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Olympus LMG",
    id: 15,
    weapon: 7,
    rarity: 2,
  },
  {
    name: "Tuscan LMG",
    id: 16,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Barbed Auto",
    id: 14,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "Blushed MMA",
    id: 15,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Auto Machinist",
    id: 16,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Olympus MMA",
    id: 17,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "Tuscan MMA",
    id: 18,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Barbed Launcher",
    id: 13,
    weapon: 9,
    rarity: 2,
  },
  {
    name: "Blushed Launcher",
    id: 14,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Machinist Launcher",
    id: 15,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Olympus Launcher",
    id: 16,
    weapon: 9,
    rarity: 2,
  },
  {
    name: "Tuscan Launcher",
    id: 17,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Omen",
    glow: true,
    id: 24,
    creator: "Zino",
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Scoped Moss",
    id: 25,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Swamped Scope",
    id: 26,
    weapon: 1,
    rarity: 0,
  },
  {
    name: "Tiger Bolt",
    id: 27,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Zebra Bolt",
    id: 28,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Necron Bolt",
    id: 29,
    weapon: 1,
    rarity: 4,
    glow: true,
  },
  {
    name: "Lava Bolt",
    id: 30,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Sky Bolt",
    id: 31,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "AWP Iris",
    id: 32,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Bolt Wanderer",
    id: 33,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "Mossy Rifle",
    id: 20,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Swamped AK",
    id: 21,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Tiger Rifle",
    id: 22,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Zebra Rifle",
    id: 23,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Plasma Rifle",
    id: 24,
    weapon: 2,
    rarity: 4,
    glow: true,
  },
  {
    name: "Lava Rifle",
    id: 25,
    weapon: 2,
    glow: true,
    rarity: 3,
  },
  {
    name: "Sky Rifle",
    id: 26,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Bark AK",
    id: 27,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Rifle Wanderer",
    id: 28,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "SMG Growth",
    id: 19,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "SMG Marsh",
    id: 20,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Tigris",
    id: 21,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "SMG Safari",
    id: 22,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "Rapid Plasma",
    id: 23,
    weapon: 4,
    rarity: 4,
    glow: true,
  },
  {
    name: "Lava SMG",
    id: 24,
    weapon: 4,
    rarity: 3,
    glow: true,
  },
  {
    name: "UMP Atmos",
    id: 25,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "Birch SMG",
    id: 26,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Wanderer",
    id: 27,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Mossy Python",
    id: 19,
    weapon: 5,
    rarity: 1,
  },
  {
    name: "Swamped Revolver",
    id: 20,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Tiger Python",
    id: 21,
    weapon: 5,
    rarity: 2,
  },
  {
    name: "Zebra Python",
    id: 22,
    weapon: 5,
    rarity: 2,
  },
  {
    name: "Venomous",
    creator: "Rengar",
    glow: true,
    id: 23,
    weapon: 5,
    rarity: 3,
  },
  {
    name: "Lava Revolver",
    id: 24,
    weapon: 5,
    rarity: 3,
  },
  {
    name: "Sky Python",
    id: 25,
    weapon: 5,
    rarity: 2,
    glow: true,
  },
  {
    name: "Bark Python",
    id: 26,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Wanderer Python",
    id: 27,
    weapon: 5,
    rarity: 0,
  },
  {
    name: "Gabrand",
    id: 19,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Tennessee",
    id: 20,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "SG Tigris",
    id: 21,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Safaris",
    id: 22,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Neuromance",
    id: 23,
    weapon: 6,
    rarity: 4,
    glow: true,
  },
  {
    name: "Anatomis",
    id: 24,
    weapon: 6,
    rarity: 3,
    glow: true,
  },
  {
    name: "Sky Pump",
    id: 25,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Bark Slug",
    id: 26,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Slug Wanderer",
    id: 27,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Mossy LMG",
    id: 17,
    weapon: 7,
    rarity: 1,
  },
  {
    name: "Swamped LMG",
    id: 18,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Tiger LMG",
    id: 19,
    weapon: 7,
    rarity: 2,
  },
  {
    name: "Zebra LMG",
    id: 20,
    weapon: 7,
    rarity: 2,
  },
  {
    name: "Heavy Plasma",
    id: 21,
    weapon: 7,
    rarity: 4,
    glow: true,
  },
  {
    name: "Lava LMG",
    id: 22,
    weapon: 7,
    rarity: 3,
  },
  {
    name: "Sky LMG",
    id: 23,
    weapon: 7,
    rarity: 2,
    glow: true,
  },
  {
    name: "Bark LMG",
    id: 24,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "LMG Wanderer",
    id: 25,
    weapon: 7,
    rarity: 0,
  },
  {
    name: "Overgrowth",
    id: 19,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Marshland",
    id: 20,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Tiger MMA",
    id: 21,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "Zebra MMA",
    id: 22,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "MMA Plasma",
    id: 23,
    weapon: 8,
    rarity: 4,
    glow: true,
  },
  {
    name: "Magnis",
    id: 24,
    weapon: 8,
    rarity: 3,
    glow: true,
  },
  {
    name: "Sky AUTO",
    id: 25,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "Bark AUTO",
    id: 26,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "MMA Wanderer",
    id: 27,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Mossy Rocket",
    id: 18,
    weapon: 9,
    rarity: 1,
  },
  {
    name: "Swamped Launcher",
    id: 19,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Tiger Rocket",
    id: 20,
    weapon: 9,
    rarity: 2,
  },
  {
    name: "Zebra Launcher",
    id: 21,
    weapon: 9,
    rarity: 2,
  },
  {
    name: "Plasma Nuke",
    id: 22,
    weapon: 9,
    rarity: 4,
    glow: true,
  },
  {
    name: "Lava Rocket",
    id: 23,
    weapon: 9,
    rarity: 3,
  },
  {
    name: "Sky Launcher",
    id: 24,
    weapon: 9,
    rarity: 2,
  },
  {
    name: "Bark Launcher",
    id: 25,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Wanderer Rocket",
    id: 26,
    weapon: 9,
    rarity: 0,
  },
  {
    name: "Purple Cap",
    id: 2,
    tex: 1,
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sitOff: 0.4,
    yOff: -3,
    xOff: 2,
    rarity: 0,
  },
  {
    name: "Bear Mask",
    id: 9,
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sclMlt: 1.3,
    sitOff: 2.05,
    yOff: -4,
    xOff: 1,
    rarity: 2,
  },
  {
    name: "Panda Mask",
    id: 9,
    tex: 1,
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sclMlt: 1.3,
    sitOff: 2.05,
    yOff: -4,
    xOff: 1,
    rarity: 2,
  },
  {
    name: "Brown Beard",
    id: 11,
    type: 1,
    keyW: "Head",
    scl: 2.8,
    sclMlt: 0.9,
    sitOff: 2,
    yOff: -3,
    rarity: 2,
  },
  {
    name: "Blonde Beard",
    id: 11,
    tex: 1,
    type: 1,
    keyW: "Head",
    scl: 2.8,
    sclMlt: 0.9,
    sitOff: 2,
    yOff: -3,
    rarity: 2,
  },
  {
    name: "Skull Mask",
    id: 12,
    type: 1,
    keyW: "Head",
    scl: 3,
    glow: true,
    sclMlt: 1.05,
    sitOff: 2.5,
    sitOffZ: 1.1,
    yOff: -4.5,
    xOff: -3,
    tex: 0,
    rarity: 3,
  },
  {
    name: "Red Beanie",
    id: 13,
    type: 1,
    keyW: "Head",
    scl: 3,
    sclMlt: 1.1,
    sitOff: 0.4,
    yOff: -3,
    tex: 0,
    rarity: 0,
  },
  {
    name: "Blue Beanie",
    id: 13,
    type: 1,
    keyW: "Head",
    scl: 3,
    sclMlt: 1.1,
    sitOff: 0.4,
    yOff: -3,
    tex: 1,
    rarity: 0,
  },
  {
    name: "Krunk Headset",
    id: 14,
    type: 1,
    keyW: "Head",
    scl: 2,
    sclMlt: 1.1,
    sitOff: 1.4,
    yOff: -4,
    rarity: 2,
  },
  {
    name: "Cherry Headset",
    id: 14,
    type: 1,
    keyW: "Head",
    tex: 1,
    scl: 2,
    sclMlt: 1.1,
    sitOff: 1.4,
    yOff: -4,
    rarity: 2,
  },
  {
    name: "Demonic Wings",
    id: 0,
    type: 2,
    keyW: "Back",
    glow: true,
    scl: 3.5,
    sclMlt: 3,
    xOff: -1.5,
    sitOff: -1.3,
    sitOffZ: -1.4,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Bass Guitar",
    id: 1,
    type: 2,
    keyW: "Back",
    scl: 4,
    sclMlt: 3.8,
    sitOff: -1.3,
    sitOffZ: -1,
    yOff: -2,
    rarity: 2,
  },
  {
    name: "Samurai Blades",
    id: 2,
    type: 2,
    keyW: "Back",
    glow: true,
    scl: 0.00048112055276382,
    sclMlt: 0.000406279577889448,
    sitOff: -1.3,
    sitOffZ: -0.95,
    yOff: -1,
    xOff: -0.5,
    rarity: 3,
  },
  {
    name: "Blood Harvest",
    id: 3,
    type: 2,
    keyW: "Back",
    glow: true,
    scl: 5.1,
    sclMlt: 5,
    sitOff: -1.3,
    sitOffZ: -0.95,
    yOff: -1,
    rarity: 3,
  },
  {
    name: "Panda Body",
    id: 4,
    type: 2,
    keyW: "Back",
    scl: 2.1,
    sclMlt: 1.3,
    sitOff: 2.2,
    sitOffZ: 0,
    yOff: -5,
    rarity: 3,
  },
  {
    name: "Bear Body",
    id: 4,
    tex: 1,
    type: 2,
    keyW: "Back",
    scl: 2.1,
    sclMlt: 1.3,
    sitOff: 2.2,
    sitOffZ: 0,
    yOff: -5,
    rarity: 3,
  },
  {
    name: "Angelic Wings",
    id: 5,
    type: 2,
    keyW: "Back",
    glow: true,
    scl: 3.5,
    sclMlt: 3.6,
    xOff: -1.5,
    sitOff: -1.3,
    sitOffZ: -1.4,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Ninja Mask",
    id: 15,
    glow: true,
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sclMlt: 1.1,
    sitOff: 2.05,
    yOff: -4,
    xOff: 0,
    rarity: 3,
  },
  {
    name: "Halo",
    id: 16,
    glow: true,
    type: 1,
    keyW: "Head",
    scl: 3.5,
    sclMlt: 1.1,
    sitOff: -0.65,
    yOff: -1,
    rarity: 3,
  },
  {
    name: "Welder Mask",
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sitOff: 2.1,
    yOff: -3,
    xOff: 1,
    id: 17,
    rarity: 1,
  },
  {
    name: "Diver Goggles",
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sclMlt: 0.9,
    sitOff: 1,
    yOff: -1,
    id: 18,
    rarity: 1,
  },
  {
    name: "Mad Cap",
    type: 1,
    keyW: "Head",
    tex: 2,
    scl: 2.5,
    sitOff: 0.4,
    yOff: -3,
    xOff: 2,
    id: 2,
    rarity: 1,
  },
  {
    name: "Ace Cap",
    type: 1,
    keyW: "Head",
    tex: 3,
    scl: 2.5,
    sitOff: 0.4,
    yOff: -3,
    xOff: 2,
    id: 2,
    rarity: 1,
  },
  {
    name: "Ice Cap",
    type: 1,
    keyW: "Head",
    tex: 4,
    scl: 2.5,
    sitOff: 0.4,
    yOff: -3,
    xOff: 2,
    id: 2,
    rarity: 1,
  },
  {
    name: "Soldier Pack",
    id: 6,
    type: 2,
    keyW: "Back",
    glow: true,
    scl: 2.6,
    sclMlt: 1.8,
    xOff: 1,
    sitOff: 1.3,
    sitOffZ: -1.75,
    yOff: -5,
    rarity: 1,
  },
  {
    name: "Robo Wings",
    id: 7,
    type: 2,
    keyW: "Back",
    glow: true,
    scl: 5,
    sclMlt: 3.9,
    xOff: -3.5,
    sitOff: -1.3,
    sitOffZ: -0.75,
    yOff: -4,
    rarity: 4,
  },
  {
    name: "Basket",
    id: 8,
    type: 2,
    keyW: "Back",
    scl: 3.5,
    sclMlt: 2,
    xOff: -1.5,
    sitOff: 0.75,
    sitOffZ: -0.8,
    yOff: -4,
    rarity: 1,
  },
  {
    name: "Baby Panda",
    id: 9,
    type: 2,
    keyW: "Back",
    scl: 3.5,
    sclMlt: 2,
    xOff: 1,
    sitOff: 0.75,
    sitOffZ: -0.8,
    yOff: -5,
    xRot: Math.PI,
    rarity: 3,
  },
  {
    name: "Sturm Helmet",
    type: 1,
    keyW: "Head",
    tex: 1,
    scl: 2.8,
    sclMlt: 1,
    sitOff: 0.65,
    yOff: -2.5,
    id: 4,
    rarity: 1,
  },
  {
    name: "Brown Afro",
    type: 1,
    keyW: "Head",
    tex: 1,
    scl: 2,
    sclMlt: 0.9,
    sitOff: 1.4,
    yOff: -4,
    id: 6,
    rarity: 0,
  },
  {
    name: "Acid Skull",
    id: 12,
    type: 1,
    keyW: "Head",
    tex: 1,
    scl: 3,
    glow: true,
    sclMlt: 1.05,
    sitOff: 2.5,
    sitOffZ: 1.1,
    yOff: -4.5,
    xOff: -3,
    rarity: 3,
  },
  {
    name: "Uranium",
    type: 1,
    keyW: "Head",
    tex: 1,
    scl: 2.5,
    sitOff: 2.1,
    yOff: -3,
    xOff: 1,
    id: 17,
    rarity: 2,
  },
  {
    name: "Panda King",
    id: 19,
    glow: true,
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sclMlt: 1.3,
    sitOff: 2.05,
    yOff: -4,
    xOff: 1,
    rarity: 3,
  },
  {
    name: "Kolt Rifle",
    creator: "iSpy",
    id: 35,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Pace Dore",
    id: 34,
    glow: true,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Shot Element",
    creator: "Electrode_",
    glow: true,
    id: 28,
    weapon: 6,
    rarity: 3,
  },
  {
    name: "Warp Sequence",
    creator: "Electrode_",
    id: 28,
    glow: true,
    weapon: 4,
    rarity: 4,
  },
  {
    name: "Radioactive",
    creator: "Electrode_",
    glow: true,
    id: 29,
    weapon: 5,
    rarity: 4,
  },
  {
    name: "Targeted",
    creator: "Subza",
    glow: true,
    id: 28,
    weapon: 5,
    rarity: 3,
  },
  {
    name: "Robot Helmet",
    type: 1,
    keyW: "Head",
    glow: true,
    scl: 2.4,
    sclMlt: 1,
    sitOff: 2,
    yOff: -3.4,
    id: 20,
    rarity: 3,
  },
  {
    name: "Knight Helmet",
    type: 1,
    keyW: "Head",
    scl: 2.3,
    sclMlt: 1,
    sitOff: 2,
    yOff: -3.2,
    id: 21,
    rarity: 3,
  },
  {
    name: "Cat Ears",
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sclMlt: 1.2,
    sitOff: 1.65,
    yOff: -3.2,
    id: 22,
    rarity: 2,
  },
  {
    name: "Snowman",
    type: 1,
    keyW: "Head",
    scl: 2.2,
    sclMlt: 1,
    sitOff: 2.05,
    yOff: -3.2,
    id: 23,
    rarity: 2,
  },
  {
    name: "Trendy Biker",
    type: 1,
    keyW: "Head",
    scl: 2.2,
    sclMlt: 1,
    sitOff: 1.8,
    yOff: -3.2,
    id: 24,
    rarity: 3,
  },
  {
    name: "Golden Crown",
    type: 1,
    keyW: "Head",
    glow: true,
    scl: 2.4,
    sclMlt: 1,
    sitOff: 0.65,
    yOff: -3.2,
    id: 25,
    rarity: 3,
  },
  {
    name: "Master Drinker",
    type: 1,
    keyW: "Head",
    scl: 2.4,
    sclMlt: 1,
    sitOff: 0.65,
    yOff: -2.7,
    id: 26,
    rarity: 3,
  },
  {
    name: "Pig Head",
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sclMlt: 1,
    sitOff: 2.05,
    yOff: -3.2,
    id: 27,
    rarity: 3,
  },
  {
    name: "Red Bandana",
    type: 1,
    keyW: "Head",
    scl: 2.2,
    sclMlt: 1,
    sitOff: 1.6,
    yOff: -3.2,
    id: 28,
    rarity: 1,
  },
  {
    name: "Sheriff",
    type: 1,
    keyW: "Head",
    scl: 2.2,
    sclMlt: 1,
    sitOff: 2.05,
    yOff: -3.2,
    id: 29,
    rarity: 4,
  },
  {
    name: "Bandit",
    type: 1,
    keyW: "Head",
    glow: true,
    scl: 2.2,
    sclMlt: 1,
    sitOff: 2.05,
    yOff: -3.2,
    id: 30,
    rarity: 4,
  },
  {
    name: "Vlaine",
    id: 36,
    weapon: 1,
    rarity: 1,
  },
  {
    name: "AWP Supersport",
    creator: "Kitter",
    id: 37,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Reine",
    id: 38,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Melted",
    glow: true,
    id: 39,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Viper",
    glow: true,
    id: 40,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Razor",
    glow: true,
    id: 41,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Lazor",
    id: 29,
    glow: true,
    weapon: 2,
    rarity: 4,
  },
  {
    name: "Uzera",
    id: 2,
    glow: true,
    weapon: 10,
    rarity: 4,
  },
  {
    name: "Tazor",
    glow: true,
    id: 7,
    weapon: 10,
    rarity: 3,
  },
  {
    name: "Dual Woodland",
    id: 0,
    weapon: 10,
    rarity: 1,
  },
  {
    name: "Flecken Uzi",
    id: 1,
    weapon: 10,
    rarity: 1,
  },
  {
    name: "Dual Seafarer",
    id: 3,
    weapon: 10,
    rarity: 2,
  },
  {
    name: "Rapid Digital",
    id: 4,
    weapon: 10,
    rarity: 1,
  },
  {
    name: "Sap Uzi",
    id: 5,
    weapon: 10,
    rarity: 0,
  },
  {
    name: "Torn Dual",
    id: 6,
    weapon: 10,
    rarity: 1,
  },
  {
    name: "Haste",
    glow: true,
    id: 42,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Leine",
    id: 43,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Lore",
    glow: true,
    id: 44,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Reaver",
    glow: true,
    id: 45,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Splixen",
    glow: true,
    id: 46,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "AWP Stream",
    creator: "Electrode_",
    glow: true,
    id: 47,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Circuit",
    creator: "Electrode_",
    glow: true,
    id: 30,
    weapon: 2,
    rarity: 4,
  },
  {
    name: "SMG Iris",
    id: 29,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "SMG Venom",
    id: 30,
    weapon: 4,
    rarity: 2,
    glow: true,
  },
  {
    name: "SMG Wingman",
    id: 31,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "x0n-voX",
    creator: "???",
    pat: 0,
    tex: "weapons/pat/0",
    sameGlow: true,
    movT: 0.0001,
    weapon: 4,
    rarity: 5,
  },
  {
    name: "1Ad-dA0",
    creator: "???",
    pat: 0,
    tex: "weapons/pat/0",
    sameGlow: true,
    movT: 0.0001,
    weapon: 2,
    rarity: 5,
  },
  {
    name: "Raynb0w",
    creator: "???",
    pat: 1,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    weapon: 2,
    rarity: 5,
  },
  {
    name: "Raynb0w",
    creator: "???",
    pat: 1,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    weapon: 4,
    rarity: 5,
  },
  {
    name: "UMP Saphire",
    id: 32,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Jade",
    id: 33,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Plexus",
    id: 34,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Lapis",
    id: 35,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Perplex",
    id: 36,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "UMP Torpe",
    id: 37,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Como",
    id: 38,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Liquid",
    id: 39,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Clementine",
    id: 40,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "Dropper",
    id: 41,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "SMG Auburn",
    id: 42,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Laurel",
    id: 43,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Crimson",
    id: 44,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Azure",
    id: 45,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "Laguna",
    id: 46,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Cygenta",
    id: 47,
    weapon: 4,
    rarity: 1,
  },
  {
    name: "UMP Cygentro",
    id: 48,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "Chartreuse",
    id: 49,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "UMP Tortobe",
    id: 50,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "UMP Octo",
    id: 51,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "UMP Versate",
    id: 52,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "SMG Purpur",
    id: 53,
    weapon: 4,
    rarity: 2,
  },
  {
    name: "Leaf",
    id: 54,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Flame",
    id: 55,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Aqua",
    id: 56,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "Gravel",
    id: 57,
    weapon: 4,
    rarity: 0,
  },
  {
    name: "AR Saphire",
    id: 31,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "AR Jade",
    id: 32,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "AR Plexus",
    id: 33,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "AR Lapis",
    id: 34,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Perplex",
    id: 35,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Trople",
    id: 36,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "AR Altis",
    id: 37,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Liquid",
    id: 38,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Clementine",
    id: 39,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Dropper",
    id: 40,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Laurel",
    id: 41,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Crimson",
    id: 42,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Azure",
    id: 43,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Laguna",
    id: 44,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Cygenta",
    id: 45,
    weapon: 2,
    rarity: 1,
  },
  {
    name: "Cygento",
    id: 46,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Chartreuse",
    id: 47,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Tortobe",
    id: 48,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "AK Octo",
    id: 49,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Versate",
    id: 50,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Purpur",
    id: 51,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Leaf",
    id: 52,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Flame",
    id: 53,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Aqua",
    id: 54,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Gravel",
    id: 55,
    weapon: 2,
    rarity: 0,
  },
  {
    name: "Saphire",
    id: 28,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Jade",
    id: 29,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Plexus",
    id: 30,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Lapis",
    id: 31,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Perplexum",
    id: 32,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Torped",
    id: 33,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Commo",
    id: 34,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "MMA Liquid",
    id: 35,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Dropper",
    id: 36,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "MMA Auburn",
    id: 37,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "MMA Laurel",
    id: 38,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "MMA Crimson",
    id: 39,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "MMA Azure",
    id: 40,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "MMA Laguna",
    id: 41,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "MMA Cygneta",
    id: 42,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "MMA Cygneto",
    id: 43,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "M14 Chartreuse",
    id: 44,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "MMA Tortobe",
    id: 45,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "MMA Octo",
    id: 46,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "MMA Versate",
    id: 47,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "MMA Purpur",
    id: 48,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "Nature",
    id: 49,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Flame",
    id: 50,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Aqua",
    id: 51,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Earth",
    id: 52,
    weapon: 8,
    rarity: 0,
  },
  {
    name: "Black Ice",
    creator: "Electrode_",
    id: 53,
    weapon: 8,
    rarity: 2,
  },
  {
    name: "Mach 3",
    creator: "Jytesh",
    id: 54,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Bloodripper",
    creator: "Jytesh",
    id: 55,
    weapon: 8,
    rarity: 1,
  },
  {
    name: "Theta",
    creator: "Floatingpoint",
    seas: 2,
    id: 48,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Raynb0w",
    creator: "???",
    pat: 1,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    weapon: 1,
    rarity: 5,
  },
  {
    name: "Diablo Wings",
    id: 10,
    type: 2,
    keyW: "Back",
    scl: 0.0005593478391959849,
    sclMlt: 0.0006552360402010109,
    xOff: -3,
    sitOff: -1.3,
    sitOffZ: -1.4,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "AK Gold Rush",
    creator: "_irizu",
    id: 56,
    weapon: 2,
    rarity: 3,
    seas: 2,
  },
  {
    name: "AK Mortal",
    creator: "_irizu",
    glow: true,
    id: 57,
    weapon: 2,
    rarity: 4,
  },
  {
    name: "nV Dragon",
    creator: "nightly-build7",
    id: 51,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Cherry Blossom",
    creator: "jonschmiddy",
    id: 50,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Vapormoon",
    creator: "jonschmiddy",
    id: 58,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Tesselate",
    creator: "jonschmiddy",
    id: 59,
    weapon: 2,
    rarity: 2,
  },
  {
    name: "Polydrive",
    creator: "Ziggy",
    id: 49,
    weapon: 1,
    rarity: 2,
  },
  {
    name: "Safran",
    id: 29,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Purple Rain",
    id: 30,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Cobra",
    id: 31,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Spectrum",
    id: 32,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Anodized",
    creator: "Blitz-.",
    id: 33,
    weapon: 6,
    rarity: 3,
  },
  {
    name: "Blunderbuss",
    creator: "Blitz-.",
    id: 34,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Tv Tron A",
    type: 1,
    keyW: "Head",
    glow: true,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    id: 32,
    rarity: 4,
  },
  {
    name: "Tv Tron B",
    tex: 1,
    type: 1,
    keyW: "Head",
    glow: true,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    id: 32,
    rarity: 4,
  },
  {
    name: "Hollow Fade",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    tex: 2,
    id: 0,
    type: 3,
    scl: 2,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 5,
  },
  {
    name: "Tv Tron C",
    tex: 2,
    type: 1,
    keyW: "Head",
    glow: true,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    id: 32,
    rarity: 4,
  },
  {
    name: "Tv Tron D",
    tex: 3,
    type: 1,
    keyW: "Head",
    glow: true,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    id: 32,
    rarity: 4,
  },
  {
    name: "AWP Dazzle",
    glow: true,
    id: 53,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Octodance",
    glow: true,
    id: 54,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Ice Fade",
    glow: true,
    id: 55,
    weapon: 1,
    rarity: 4,
  },
  {
    name: "Frostlance",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    tex: 3,
    id: 0,
    type: 3,
    scl: 2,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 5,
  },
  {
    name: "Frostbite",
    keyW: "Axe",
    priceMlt: 4,
    animInd: 1,
    glow: true,
    id: 1,
    type: 3,
    scl: 2,
    sclMlt: 0.9,
    yOff: -0.5,
    rarity: 6,
  },
  {
    name: "Arctic",
    id: 0,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "Autumn Burst",
    id: 1,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "Reticle Burst",
    id: 2,
    weapon: 15,
    rarity: 2,
  },
  {
    name: "Digital Burst",
    id: 3,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "Bushwalker",
    id: 4,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "Woodland",
    id: 5,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "Burst Hazard",
    id: 6,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "Kodac Famas",
    id: 7,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "Seafarer G2",
    id: 8,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "G2 Trail",
    id: 9,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "Burst Fade",
    id: 10,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "G2 Puma",
    id: 11,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "Burst Carbo",
    id: 12,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "G2 Barb",
    id: 13,
    weapon: 15,
    rarity: 2,
  },
  {
    name: "F1 Blush",
    id: 14,
    weapon: 15,
    rarity: 0,
  },
  {
    name: "Machinist",
    id: 15,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "Triple Olympus",
    id: 16,
    weapon: 15,
    rarity: 2,
  },
  {
    name: "Honey Badger",
    id: 17,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "G2 Moss",
    id: 18,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "F1 Marshland",
    id: 19,
    weapon: 15,
    rarity: 1,
  },
  {
    name: "G2 Tigris",
    id: 20,
    weapon: 15,
    rarity: 2,
  },
  {
    name: "Zebra Burst",
    id: 21,
    weapon: 15,
    rarity: 2,
  },
  {
    name: "Skyfarer",
    id: 22,
    weapon: 15,
    rarity: 2,
  },
  {
    name: "Commando Fade",
    id: 23,
    weapon: 15,
    rarity: 2,
  },
  {
    name: "Mindseeker",
    id: 24,
    glow: true,
    weapon: 15,
    rarity: 4,
  },
  {
    name: "Intervention VI",
    mid: 0,
    glow: true,
    pulsT: 0.0015,
    scl: 0.00094830394974876,
    mScl: 0.0010536710552764,
    zOff: -0.25,
    seas: 2,
    yOff: 0.05,
    weapon: 1,
    rarity: 5,
  },
  {
    name: "Intervention XI",
    mid: 0,
    midT: 1,
    glow: true,
    seas: 2,
    pulsT: 0.0015,
    scl: 0.00094830394974876,
    mScl: 0.0010536710552764,
    zOff: -0.25,
    yOff: 0.05,
    weapon: 1,
    rarity: 5,
  },
  {
    name: "Soul Fang",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    pulsT: 0.1,
    id: 2,
    type: 3,
    scl: 3,
    seas: 2,
    sclMlt: 0.98,
    yOff: -2,
    rarity: 5,
  },
  {
    name: "Dusk Fang",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    tex: 4,
    id: 0,
    type: 3,
    scl: 2,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Boneclaw",
    id: 56,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Blue Digital",
    id: 57,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Digital",
    id: 58,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Digital",
    id: 59,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Digital",
    id: 60,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Cascade",
    id: 61,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Poly",
    id: 62,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Poly",
    id: 63,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 64,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 65,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "War Torn",
    id: 66,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Spook",
    id: 67,
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Pink Drip",
    id: 68,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Drip",
    id: 69,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sepia",
    id: 70,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Olive",
    id: 71,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Spruce",
    id: 72,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Dijon",
    id: 73,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Splat",
    id: 74,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Splat",
    id: 75,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Splat",
    id: 76,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Splat",
    id: 77,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Yellow Poly",
    id: 78,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Poly",
    id: 79,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 80,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 81,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sandstorm",
    id: 82,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Fabrica",
    id: 83,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Azazel",
    creator: "Lxckless",
    id: 84,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Picnic",
    id: 85,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Picasso",
    id: 86,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Cracked",
    id: 87,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Fire Stream",
    id: 88,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ripped Sun",
    id: 89,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Bliss Flow",
    id: 90,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Kenzo",
    id: 91,
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Snowy",
    id: 92,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Galaxy",
    id: 93,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ducky",
    id: 94,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Graphite",
    id: 95,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Porcelain",
    id: 96,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Neon Spill",
    id: 97,
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Danger",
    id: 98,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Paint Spill",
    id: 99,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Goop",
    id: 100,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cerise",
    id: 101,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Orange Drip",
    id: 102,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Drip",
    id: 103,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Green Drip",
    id: 104,
    weapon: 1,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Flame Viper",
    id: 105,
    weapon: 1,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Red Phantom",
    id: 106,
    weapon: 1,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Arctic",
    creator: "Blitz",
    id: 107,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Magma Core",
    id: 108,
    weapon: 1,
    rarity: 4,
    animInd: 1,
    pulsT: 0.1,
    glow: true,
    seas: 2,
  },
  {
    name: "Wired",
    creator: "Floatingpoint",
    id: 109,
    weapon: 1,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Kings",
    creator: "Floatingpoint",
    id: 110,
    weapon: 1,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Tessalate",
    id: 111,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Sunset",
    creator: "Graham",
    id: 112,
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Poly Blush",
    id: 113,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cuircuitor",
    creator: "Gnnr",
    id: 114,
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Marbled .50",
    creator: "Blitz",
    id: 115,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Exoscarlet",
    creator: "CyAnIdE",
    id: 116,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sorable V",
    creator: "Zino",
    id: 117,
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Boneclaw",
    id: 60,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Blue Digital",
    id: 61,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Digital",
    id: 62,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Digital",
    id: 63,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Digital",
    id: 64,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Cascade",
    id: 65,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Poly",
    id: 66,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Poly",
    id: 67,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 68,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 69,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "War Torn",
    id: 70,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Phantasma",
    id: 72,
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Pink Drip",
    id: 73,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Drip",
    id: 74,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sepia",
    id: 75,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Olive",
    id: 76,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Spruce",
    id: 77,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Dijon",
    id: 78,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Splat",
    id: 79,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Splat",
    id: 80,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Splat",
    id: 81,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Splat",
    id: 82,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Yellow Poly",
    id: 83,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Poly",
    id: 84,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 85,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 86,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sandstorm",
    id: 87,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Fabrica",
    id: 88,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Zebrik",
    id: 89,
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Picnic",
    id: 90,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Picasso",
    id: 91,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Cracked",
    id: 92,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Fire Stream",
    id: 93,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ripped Sun",
    id: 94,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Bliss Flow",
    id: 95,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Snowy",
    id: 96,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Ducky",
    id: 97,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Graphite",
    id: 98,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Porcelain",
    id: 99,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Danger",
    id: 100,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Paint Spill",
    id: 101,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Goop",
    id: 102,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cerise",
    id: 103,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Orange Drip",
    id: 104,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Drip",
    id: 105,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Green Drip",
    id: 106,
    weapon: 2,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Void",
    id: 107,
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Lightning Storm",
    id: 108,
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Scribbler",
    id: 109,
    weapon: 2,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Scorched",
    creator: "0mar",
    id: 110,
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Heat-Tint",
    creator: "Leaaf",
    id: 111,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Welded",
    id: 112,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Acid Howler",
    id: 113,
    weapon: 2,
    rarity: 5,
    glow: true,
    seas: 2,
  },
  {
    name: "Boneclaw",
    id: 58,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Blue Digital",
    id: 59,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Digital",
    id: 60,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Digital",
    id: 61,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Digital",
    id: 62,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Cascade",
    id: 63,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Poly",
    id: 64,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Poly",
    id: 65,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 66,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 67,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "War Torn",
    id: 68,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Drip",
    id: 69,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Drip",
    id: 70,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sepia",
    id: 71,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Olive",
    id: 72,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Spruce",
    id: 73,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Dijon",
    id: 74,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Splat",
    id: 75,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Splat",
    id: 76,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Splat",
    id: 77,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Splat",
    id: 78,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Yellow Poly",
    id: 79,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Poly",
    id: 80,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 81,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 82,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sandstorm",
    id: 83,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Fabrica",
    id: 84,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Picnic",
    id: 85,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Picasso",
    id: 86,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Cracked",
    id: 87,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Fire Stream",
    id: 88,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ripped Sun",
    id: 89,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Bliss Flow",
    id: 90,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Snowy",
    id: 91,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Ducky",
    id: 92,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Graphite",
    id: 93,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Porcelain",
    id: 94,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Danger",
    id: 95,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Paint Spill",
    id: 96,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Goop",
    id: 97,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cerise",
    id: 98,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Orange Drip",
    id: 99,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Drip",
    id: 100,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Green Drip",
    id: 101,
    weapon: 4,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Polymer",
    id: 102,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Andromeda",
    id: 103,
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Liberty",
    id: 104,
    weapon: 4,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Dragon Breath",
    id: 105,
    weapon: 4,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Parabellum",
    creator: "Floatingpoint",
    id: 106,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Poly Fade",
    id: 107,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Picnic",
    id: 31,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Picasso",
    id: 32,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Cracked",
    id: 33,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Fire Stream",
    id: 34,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ripped Sun",
    id: 35,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Bliss Flow",
    id: 36,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Snowy",
    id: 37,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Ducky",
    id: 38,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Graphite",
    id: 39,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Porcelain",
    id: 40,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Danger",
    id: 41,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Paint Spill",
    id: 42,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Slime Spill",
    id: 43,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cerise",
    id: 44,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Orange Drip",
    id: 45,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Drip",
    id: 46,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Green Drip",
    id: 47,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Overheated",
    id: 48,
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Royal",
    id: 49,
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Nordic",
    id: 50,
    weapon: 5,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Boneclaw",
    id: 51,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Blue Digital",
    id: 52,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Digital",
    id: 53,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Digital",
    id: 54,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Digital",
    id: 55,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Cascade",
    id: 56,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Poly",
    id: 57,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Poly",
    id: 58,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 59,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 60,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "War Torn",
    id: 61,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Drip",
    id: 62,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Drip",
    id: 63,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sepia",
    id: 64,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Olive",
    id: 65,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Spruce",
    id: 66,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Dijon",
    id: 67,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Splat",
    id: 68,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Splat",
    id: 69,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Splat",
    id: 70,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Splat",
    id: 71,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Yellow Poly",
    id: 72,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Poly",
    id: 73,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 74,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 75,
    weapon: 5,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sandstorm",
    id: 76,
    weapon: 5,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Fabrica",
    id: 77,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Outlaw",
    id: 78,
    weapon: 5,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 26,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 27,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sandstorm",
    id: 28,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Fabrica",
    id: 29,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Zebrik",
    id: 30,
    weapon: 7,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Picnic",
    id: 31,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Picasso",
    id: 32,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Cracked",
    id: 33,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Fire Stream",
    id: 34,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ripped Sun",
    id: 35,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Bliss Flow",
    id: 36,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Snowy",
    id: 37,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Ducky",
    id: 38,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Graphite",
    id: 39,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Porcelain",
    id: 40,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Danger",
    id: 41,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Paint Spill",
    id: 42,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Slime Spill",
    id: 43,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cerise",
    id: 44,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Orange Drip",
    id: 45,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Drip",
    id: 46,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Green Drip",
    id: 47,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Neoran",
    id: 48,
    weapon: 7,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Fire Breath",
    id: 49,
    weapon: 7,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Boneclaw",
    id: 50,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Blue Digital",
    id: 51,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Digital",
    id: 52,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Digital",
    id: 53,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Digital",
    id: 54,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Cascade",
    id: 55,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Poly",
    id: 56,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Poly",
    id: 57,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 58,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 59,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "War Torn",
    id: 60,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Drip",
    id: 61,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Drip",
    id: 62,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sepia",
    id: 63,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Olive",
    id: 64,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Spruce",
    id: 65,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Dijon",
    id: 66,
    weapon: 7,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Splat",
    id: 67,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Splat",
    id: 68,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Splat",
    id: 69,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Splat",
    id: 70,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Yellow Poly",
    id: 71,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Bloodbath",
    id: 72,
    weapon: 7,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Red Poly",
    id: 73,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 27,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sandstorm",
    id: 28,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Fabrica",
    id: 29,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Picnic",
    id: 30,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Picasso",
    id: 31,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Cracked",
    id: 32,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Fire Stream",
    id: 33,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ripped Sun",
    id: 34,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Bliss Flow",
    id: 35,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Kenzo",
    id: 36,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Snowy",
    id: 37,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Ducky",
    id: 38,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Graphite",
    id: 39,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Porcelain",
    id: 40,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Danger",
    id: 41,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Paint Spill",
    id: 42,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Goop",
    id: 43,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cerise",
    id: 44,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Orange Drip",
    id: 45,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Drip",
    id: 46,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Green Drip",
    id: 47,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Boneclaw",
    id: 48,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Blue Digital",
    id: 49,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Digital",
    id: 50,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Digital",
    id: 51,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Digital",
    id: 52,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Cascade",
    id: 53,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Poly",
    id: 54,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Poly",
    id: 55,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 56,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 57,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "War Torn",
    id: 58,
    weapon: 9,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Drip",
    id: 59,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Drip",
    id: 60,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sepia",
    id: 61,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Olive",
    id: 62,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Spruce",
    id: 63,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Dijon",
    id: 64,
    weapon: 9,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Splat",
    id: 65,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Splat",
    id: 66,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Splat",
    id: 67,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Splat",
    id: 68,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Yellow Poly",
    id: 69,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Poly",
    id: 70,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 71,
    weapon: 9,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Coffin",
    id: 72,
    weapon: 9,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Lightning Strike",
    id: 73,
    weapon: 9,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Boneclaw",
    id: 25,
    weapon: 15,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Blue Digital",
    id: 26,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Digital",
    id: 27,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Digital",
    id: 28,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Digital",
    id: 29,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Cascade",
    id: 30,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pink Poly",
    id: 31,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Poly",
    id: 32,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 33,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 34,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "War Torn",
    id: 35,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Spook",
    id: 36,
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Pink Drip",
    id: 37,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Drip",
    id: 38,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sepia",
    id: 39,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Olive",
    id: 40,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Spruce",
    id: 41,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Dijon",
    id: 42,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Splat",
    id: 43,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Purple Splat",
    id: 44,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Orange Splat",
    id: 45,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Splat",
    id: 46,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Yellow Poly",
    id: 47,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Red Poly",
    id: 48,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Green Poly",
    id: 49,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Blue Poly",
    id: 50,
    weapon: 15,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sandstorm",
    id: 51,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Fabrica",
    id: 52,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Zebrik",
    id: 53,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Picnic",
    id: 54,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Picasso",
    id: 55,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Cracked",
    id: 56,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Fire Stream",
    id: 57,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Ripped Sun",
    id: 58,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Bliss Flow",
    id: 59,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Kenzo",
    id: 60,
    weapon: 15,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Snowy",
    id: 61,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Ducky",
    id: 62,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Graphite",
    id: 63,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Porcelain",
    id: 64,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Danger",
    id: 65,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Paint Spill",
    id: 66,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Slime Spill",
    id: 67,
    weapon: 15,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Cerise",
    id: 68,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Orange Drip",
    id: 69,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Red Drip",
    id: 70,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Green Drip",
    id: 71,
    weapon: 15,
    rarity: 0,
    seas: 2,
  },
  {
    name: "Galaxy Morse",
    id: 72,
    weapon: 15,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Fire Storm",
    id: 73,
    weapon: 15,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Marked",
    id: 74,
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Frosted",
    id: 75,
    weapon: 15,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Gold Tipped",
    creator: "jonschmiddy",
    id: 76,
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Damascus",
    keyW: "Knife",
    tex: 6,
    id: 0,
    type: 3,
    scl: 2.3,
    seas: 2,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 3,
  },
  {
    name: "Prism",
    creator: "jonschmiddy",
    keyW: "Knife",
    tex: 7,
    id: 0,
    type: 3,
    scl: 2.3,
    seas: 2,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 3,
  },
  {
    name: "Bloodless",
    keyW: "Knife",
    id: 2,
    tex: 1,
    glow: true,
    type: 3,
    scl: 3,
    seas: 2,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Steelfang",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    type: 3,
    scl: 2.6,
    seas: 2,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 4,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Flamefang",
    keyW: "Knife",
    flipAnim: true,
    tex: 1,
    glow: true,
    id: 3,
    type: 3,
    scl: 2.6,
    seas: 2,
    sclMlt: 0.9,
    yOff: -1,
    xOff: -1.5,
    rarity: 5,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Plasma Dust",
    keyW: "Knife",
    flipAnim: true,
    tex: 2,
    glow: true,
    id: 3,
    type: 3,
    scl: 2.6,
    seas: 2,
    sclMlt: 0.9,
    yOff: -1,
    xOff: -1.5,
    rarity: 5,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Volt Fang",
    keyW: "Knife",
    flipAnim: true,
    tex: 3,
    glow: true,
    id: 3,
    type: 3,
    scl: 2.6,
    seas: 2,
    sclMlt: 0.9,
    yOff: -1,
    xOff: -1.5,
    rarity: 5,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Black Cowboy Hat",
    type: 1,
    keyW: "Head",
    id: 39,
    rarity: 0,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
  },
  {
    name: "Brown Cowboy Hat",
    type: 1,
    keyW: "Head",
    id: 39,
    tex: 1,
    rarity: 0,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Outback Hat",
    type: 1,
    keyW: "Head",
    id: 40,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Dundee Hat",
    type: 1,
    keyW: "Head",
    id: 40,
    tex: 1,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Red Hat",
    type: 1,
    keyW: "Head",
    id: 41,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Blue Hat",
    type: 1,
    keyW: "Head",
    id: 41,
    tex: 1,
    rarity: 0,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Urban Soldier",
    type: 1,
    keyW: "Head",
    id: 42,
    tex: 0,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.78,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Desert Soldier",
    type: 1,
    keyW: "Head",
    id: 42,
    tex: 1,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.78,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Arctic Soldier",
    type: 1,
    keyW: "Head",
    id: 42,
    tex: 2,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.78,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Ace",
    type: 1,
    keyW: "Head",
    id: 43,
    rarity: 3,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.7,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Pinata",
    type: 1,
    keyW: "Head",
    id: 44,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Sombrerro",
    type: 1,
    keyW: "Head",
    id: 44,
    tex: 1,
    rarity: 1,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 0.6,
    yOff: -1.2,
    scl: 1.2,
  },
  {
    name: "Swagger",
    type: 1,
    keyW: "Head",
    id: 45,
    rarity: 3,
    seas: 2,
    sclMlt: 0.56,
    sitOff: 1.8,
    yOff: -2,
    scl: 1.2,
  },
  {
    name: "Acid Bane",
    id: 11,
    rarity: 3,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 5,
    sclMlt: 3.4,
    sitOff: -1.3,
    sitOffZ: -0.8,
    yOff: -2,
    xOff: -4,
  },
  {
    name: "Plasma Bones",
    id: 11,
    tex: 1,
    rarity: 3,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 5,
    sclMlt: 3.4,
    sitOff: -1.3,
    sitOffZ: -0.8,
    yOff: -2,
    xOff: -4,
  },
  {
    name: "Jet Pack",
    id: 13,
    rarity: 2,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 6,
    sclMlt: 3,
    sitOff: -0.5,
    sitOffZ: -0.93,
    yOff: -1.3,
    xRot: Math.PI,
  },
  {
    name: "Red Backpack",
    id: 14,
    rarity: 1,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 4,
    sclMlt: 2.3,
    sitOff: -0.8,
    sitOffZ: -0.8,
    yOff: -1.5,
    xRot: Math.PI,
  },
  {
    name: "Blue Backpack",
    id: 14,
    tex: 1,
    rarity: 1,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 3.5,
    sclMlt: 2.3,
    sitOff: -0.8,
    sitOffZ: -0.8,
    yOff: -1.5,
    xRot: Math.PI,
  },
  {
    name: "Police Vest",
    id: 15,
    rarity: 1,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 4.5,
    sclMlt: 2.5,
    sitOff: 0.4,
    sitOffZ: 0,
    yOff: -2,
    xRot: Math.PI,
  },
  {
    name: "Angelic Wings",
    id: 16,
    rarity: 3,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 3,
    sclMlt: 3,
    sitOff: -0.5,
    sitOffZ: -2,
    xOff: -2,
    yOff: -3,
  },
  {
    name: "Gradient Pennon",
    id: 16,
    tex: 1,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 3,
    sclMlt: 3,
    sitOff: -0.5,
    sitOffZ: -2,
    xOff: -2,
    yOff: -3,
  },
  {
    name: "Torn Aileron",
    id: 17,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 3,
    sclMlt: 3,
    sitOff: 0,
    sitOffZ: -2,
    xOff: -2,
    yOff: -3,
  },
  {
    name: "Cursed",
    id: 17,
    tex: 1,
    rarity: 3,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 3,
    sclMlt: 3,
    sitOff: 0,
    sitOffZ: -2,
    xOff: -2,
    yOff: -3,
  },
  {
    name: "Butterfly",
    id: 19,
    rarity: 2,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 3.5,
    sclMlt: 3.3,
    sitOff: -0.9,
    sitOffZ: -2.4,
    yOff: -2,
  },
  {
    name: "Mr. Rabbiton",
    id: 46,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Madman",
    id: 47,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.95,
    sitOff: 0.8,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Grizz Lee",
    id: 48,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.95,
    sitOff: 0.8,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Claws",
    id: 48,
    tex: 1,
    rarity: 3,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Simba",
    id: 49,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Captain Walrus",
    id: 50,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Monke",
    id: 51,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Lord Panda",
    id: 52,
    rarity: 3,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Ray Bam",
    id: 53,
    rarity: 0,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.51,
    sitOff: 1.1,
    scl: 1.4,
    xOff: 1.5,
    yOff: -1.2,
  },
  {
    name: "Gold Sunnies",
    id: 53,
    tex: 1,
    rarity: 1,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.51,
    sitOff: 1.1,
    scl: 1.4,
    xOff: 1.5,
    yOff: -1.2,
  },
  {
    name: "Queens Guard",
    id: 54,
    rarity: 0,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.6,
    sitOff: 0.9,
    scl: 0.9,
    yOff: -2.1,
  },
  {
    name: "Snowman",
    id: 55,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.8,
    xOff: 1.5,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Misty",
    id: 56,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Unicorn",
    id: 57,
    rarity: 3,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "TV Tron LCD",
    id: 32,
    tex: 4,
    rarity: 4,
    type: 1,
    keyW: "Head",
    seas: 2,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    frames: 2,
    frameT: 400,
  },
  {
    name: "Acidic Bane",
    id: 36,
    rarity: 3,
    glow: true,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.56,
    sitOff: 1.3,
    xOff: 1.2,
    scl: 1.1,
    yOff: -1.2,
  },
  {
    name: "Tentacus",
    id: 34,
    tex: 1,
    rarity: 3,
    glow: true,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.56,
    sitOff: 1.3,
    scl: 1.1,
    yOff: -1.2,
  },
  {
    name: "Soldier 159",
    id: 35,
    tex: 1,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.56,
    sitOff: 1.3,
    scl: 1.1,
    yOff: -1.2,
  },
  {
    name: "Soldier 160",
    id: 35,
    tex: 2,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.56,
    sitOff: 1.3,
    scl: 1.1,
    yOff: -1.2,
  },
  {
    name: "Templar",
    id: 37,
    rarity: 3,
    type: 1,
    glow: true,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.56,
    sitOff: 1.3,
    scl: 1.1,
    yOff: -1.2,
  },
  {
    name: "Phase Blades",
    id: 2,
    tex: 1,
    type: 2,
    seas: 2,
    keyW: "Back",
    glow: true,
    scl: 0.00048112055276382,
    sclMlt: 0.000406279577889448,
    sitOff: -1.3,
    sitOffZ: -0.95,
    yOff: -1,
    xOff: -0.5,
    rarity: 3,
  },
  {
    name: "Pot'O'Gold",
    id: 20,
    rarity: 2,
    type: 2,
    keyW: "Back",
    seas: 2,
    sclMlt: 2.5,
    sitOff: -0.8,
    sitOffZ: -2,
    yOff: -2,
    xOff: 0.5,
    scl: 4,
    xRot: Math.PI,
  },
  {
    name: "Unicorn Backpack",
    id: 21,
    rarity: 3,
    type: 2,
    keyW: "Back",
    seas: 2,
    sclMlt: 2.3,
    sitOff: -0.8,
    sitOffZ: -0.8,
    yOff: -2,
    xOff: -1.5,
    scl: 3.5,
    xRot: Math.PI,
  },
  {
    name: "Flame Talon",
    weapon: 5,
    glow: true,
    id: 79,
    seas: 2,
    rarity: 4,
  },
  {
    name: "Raynb0w",
    creator: "???",
    pat: 1,
    seas: 2,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    weapon: 7,
    rarity: 5,
  },
  {
    name: "Raynb0w",
    creator: "???",
    pat: 1,
    seas: 2,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    weapon: 5,
    rarity: 5,
  },
  {
    name: "Terminal",
    id: 39,
    type: 4,
    rarity: 0,
    seas: 2,
    opacity: 0.6,
    frames: 2,
    frameT: 250,
    keyW: "Sprays",
  },
  {
    name: "Clickbait",
    id: 40,
    type: 4,
    rarity: 2,
    seas: 2,
    opacity: 0.75,
    frames: 2,
    frameT: 550,
    keyW: "Sprays",
  },
  {
    name: "Kunai",
    keyW: "Knife",
    glow: true,
    pulsT: 0.0015,
    id: 4,
    type: 3,
    seas: 2,
    rarity: 4,
    scl: 2,
    sclMlt: 0.75,
    yOff: -1,
    sxOff: 0,
    syOff: -0.05,
    szOff: -0.1,
  },
  {
    name: "Wrench",
    keyW: "Knife",
    id: 5,
    type: 3,
    seas: 2,
    rarity: 4,
    scl: 2,
    sclMlt: 0.8,
    yOff: -2.5,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Clown",
    id: 58,
    rarity: 3,
    type: 1,
    keyW: "Head",
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.9,
    scl: 1.6,
    yOff: -1.2,
  },
  {
    name: "Wink",
    id: 41,
    type: 4,
    rarity: 1,
    seas: 2,
    opacity: 0.75,
    frames: 2,
    frameT: 550,
    keyW: "Sprays",
  },
  {
    name: "No U",
    id: 42,
    type: 4,
    rarity: 1,
    seas: 2,
    opacity: 0.75,
    frames: 2,
    frameT: 550,
    keyW: "Sprays",
  },
  {
    name: "Coolman",
    id: 43,
    type: 4,
    rarity: 1,
    seas: 2,
    opacity: 0.75,
    frames: 2,
    frameT: 550,
    keyW: "Sprays",
  },
  {
    name: "Paranoid",
    id: 44,
    type: 4,
    rarity: 0,
    seas: 2,
    opacity: 0.75,
    frames: 2,
    frameT: 1200,
    keyW: "Sprays",
  },
  {
    name: "Dab",
    id: 45,
    type: 4,
    rarity: 1,
    seas: 2,
    opacity: 0.75,
    frames: 2,
    frameT: 400,
    keyW: "Sprays",
  },
  {
    name: "Pepereel",
    id: 46,
    type: 4,
    rarity: 1,
    seas: 2,
    opacity: 0.8,
    movT: -0.0025,
    keyW: "Sprays",
  },
  {
    name: "Wanted",
    id: 47,
    type: 4,
    rarity: 0,
    seas: 2,
    opacity: 0.75,
    keyW: "Sprays",
  },
  {
    name: "Soon&trade;",
    id: 48,
    type: 4,
    rarity: 0,
    seas: 2,
    opacity: 0.7,
    frames: 2,
    frameT: 550,
    keyW: "Sprays",
  },
  {
    name: "Art",
    id: 49,
    type: 4,
    rarity: 2,
    seas: 2,
    opacity: 0.8,
    frames: 2,
    frameT: 350,
    keyW: "Sprays",
  },
  {
    name: "Nautilus",
    id: 50,
    type: 4,
    rarity: 3,
    seas: 2,
    opacity: 0.85,
    frames: 4,
    frameT: 200,
    keyW: "Sprays",
  },
  {
    name: "Baller",
    creator: "???",
    pat: 6,
    tex: "weapons/pat/6",
    sameGlow: true,
    movT: 0.0002,
    weapon: 1,
    rarity: 5,
    seas: 2,
  },
  {
    name: "Baller",
    creator: "???",
    pat: 6,
    tex: "weapons/pat/6",
    sameGlow: true,
    movT: 0.0002,
    weapon: 2,
    rarity: 5,
    seas: 2,
  },
  {
    name: "Baller",
    creator: "???",
    pat: 6,
    tex: "weapons/pat/6",
    sameGlow: true,
    movT: 0.0002,
    weapon: 4,
    rarity: 5,
    seas: 2,
  },
  {
    name: "Baller",
    creator: "???",
    pat: 6,
    tex: "weapons/pat/6",
    sameGlow: true,
    movT: 0.0002,
    weapon: 5,
    rarity: 5,
    seas: 2,
  },
  {
    name: "TV Tron HD",
    id: 32,
    tex: 5,
    rarity: 4,
    type: 1,
    keyW: "Head",
    seas: 2,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    frames: 2,
    frameT: 400,
  },
  {
    name: "Nova Pump",
    limT: "Debug",
    lore: "First Weapon Remodel Placeholder",
    mid: 0,
    midT: 38,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Roadkill",
    mid: 0,
    midT: 1,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 3,
  },
  {
    name: "Molten Core",
    mid: 0,
    midT: 2,
    pulsT: 0.0015,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    glow: true,
    rarity: 4,
  },
  {
    name: "Mosaik",
    mid: 0,
    midT: 3,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Kiason",
    mid: 0,
    midT: 4,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Monatomic",
    mid: 0,
    midT: 5,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    glow: true,
    rarity: 3,
  },
  {
    name: "Crystalline",
    mid: 0,
    midT: 6,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    glow: true,
    rarity: 4,
  },
  {
    name: "Blue Digital",
    mid: 0,
    midT: 7,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Green Digital",
    mid: 0,
    midT: 8,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Purple Digital",
    mid: 0,
    midT: 9,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Red Digital",
    mid: 0,
    midT: 10,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 0,
  },
  {
    name: "Pink Poly",
    mid: 0,
    midT: 11,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Orange Poly",
    mid: 0,
    midT: 12,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Green Poly",
    mid: 0,
    midT: 13,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Blue Poly",
    mid: 0,
    midT: 14,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Pink Drip",
    mid: 0,
    midT: 15,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Blue Drip",
    mid: 0,
    midT: 16,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Sepia",
    mid: 0,
    midT: 17,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Olive",
    mid: 0,
    midT: 18,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Spruce",
    mid: 0,
    midT: 19,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Dijon",
    mid: 0,
    midT: 20,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Red Splat",
    mid: 0,
    midT: 21,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Purple Splat",
    mid: 0,
    midT: 22,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Orange Splat",
    mid: 0,
    midT: 23,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Green Splat",
    mid: 0,
    midT: 24,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Yellow Comb",
    mid: 0,
    midT: 25,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Red Comb",
    mid: 0,
    midT: 26,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Green Comb",
    mid: 0,
    midT: 27,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Blue Comb",
    mid: 0,
    midT: 28,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Sandstorm",
    mid: 0,
    midT: 29,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Picnic",
    mid: 0,
    midT: 30,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Picasso",
    mid: 0,
    midT: 31,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Snowy",
    mid: 0,
    midT: 32,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Hazard",
    mid: 0,
    midT: 33,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Cerise",
    mid: 0,
    midT: 34,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 2,
  },
  {
    name: "Orange Drip",
    mid: 0,
    midT: 35,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Red Drip",
    mid: 0,
    midT: 36,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Green Drip",
    mid: 0,
    midT: 37,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 1,
  },
  {
    name: "Wasteland",
    id: 118,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Turbo",
    id: 119,
    creator: "Floatingpoint",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Urban Splat",
    id: 114,
    creator: "FlowerKid",
    glow: true,
    weapon: 2,
    rarity: 4,
    seas: 2,
  },
  {
    name: "Cimota",
    id: 108,
    creator: "Cimota",
    glow: true,
    weapon: 4,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Fractal",
    id: 109,
    creator: "Cimota",
    weapon: 4,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Chrome",
    id: 80,
    creator: "Flowerkid",
    glow: true,
    weapon: 5,
    rarity: 3,
    seas: 2,
  },
  {
    name: "World of Light",
    id: 77,
    creator: "Electrode",
    glow: true,
    weapon: 15,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Vantablack",
    id: 0,
    shirtCol: 197379,
    sleeveCol: 197379,
    pantsCol: 197379,
    shoeCol: 197379,
    seas: 2,
    type: 5,
    rarity: 5,
  },
  {
    name: "Lederhose",
    id: 120,
    weapon: 1,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Emboss",
    id: 121,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Spineless",
    id: 122,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Gold Plated",
    id: 123,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Daimyo Spirit",
    creator: "FlowerKid",
    id: 124,
    weapon: 1,
    glow: true,
    rarity: 4,
    seas: 2,
  },
  {
    name: "Heat Stroke",
    id: 125,
    weapon: 1,
    glow: true,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Samurai Spirit",
    creator: "FlowerKid",
    id: 78,
    weapon: 15,
    glow: true,
    rarity: 4,
    seas: 2,
  },
  {
    name: "Suede Blade",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 4,
    type: 3,
    scl: 2.6,
    seas: 2,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 3,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Aziru",
    creator: "Halloluke0201",
    keyW: "Knife",
    flipAnim: true,
    glow: true,
    id: 3,
    tex: 5,
    type: 3,
    scl: 2.6,
    seas: 2,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 4,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Clockwork",
    id: 126,
    seas: 2,
    weapon: 1,
    rarity: 3,
  },
  {
    name: "Jagdfaust IV",
    mid: 2,
    glow: true,
    limited: true,
    scl: 0.9,
    mScl: 1,
    spnScl: 1.35,
    zOff: -0.25,
    seas: 2,
    yOff: 0.05,
    weapon: 1,
    rarity: 6,
  },
  {
    name: "Coroller",
    keyW: "Toilet",
    id: 7,
    type: 3,
    seas: 2,
    rarity: 6,
    limited: true,
    scl: 2,
    sclMlt: 0.76,
    yOff: -2.5,
    sxOff: 0.15,
  },
  {
    name: "Facemask",
    keyW: "Mask",
    limited: true,
    id: 60,
    rarity: 2,
    type: 1,
    seas: 2,
    sclMlt: 0.54,
    sitOff: 0.9,
    scl: 1.6,
  },
  {
    name: "Spectralon",
    id: 1,
    shirtCol: 16777215,
    sleeveCol: 16777215,
    pantsCol: 16777215,
    shoeCol: 16777215,
    seas: 2,
    type: 5,
    rarity: 5,
  },
  {
    name: "24/7",
    id: 127,
    creator: "Drag",
    weapon: 1,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Shattered",
    id: 128,
    creator: "Edibleporg",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Lunatic",
    id: 115,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Auzora",
    id: 116,
    creator: "Cyanide",
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Botanical",
    id: 79,
    creator: "Nxbulah",
    weapon: 15,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Krunkette 1",
    id: 51,
    type: 4,
    rarity: 5,
    seas: 2,
    opacity: 0.7,
    keyW: "Sprays",
  },
  {
    name: "Krunkette 2",
    id: 52,
    type: 4,
    rarity: 4,
    seas: 2,
    opacity: 0.7,
    keyW: "Sprays",
  },
  {
    name: "Krunkette 3",
    id: 53,
    type: 4,
    rarity: 3,
    seas: 2,
    opacity: 0.7,
    keyW: "Sprays",
  },
  {
    name: "Lunar",
    id: 117,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "S&Y",
    id: 81,
    creator: "Cimota",
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Quarantine",
    creator: "Floatingpoint",
    midT: 39,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Scarlet",
    id: 118,
    creator: "FlowerKid",
    weapon: 2,
    rarity: 5,
    glow: true,
    seas: 2,
  },
  {
    name: "Lunar Nitro",
    id: 129,
    creator: "Kitter",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Sunset Raven",
    creator: "FlowerKid",
    midT: 40,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Otzarreta",
    id: 110,
    creator: "FlowerKid",
    weapon: 4,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Wychwood",
    id: 111,
    creator: "FlowerKid",
    weapon: 4,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Trip",
    id: 112,
    creator: "Nxbulah",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Retribution",
    id: 130,
    creator: "Jhonxay_Playz",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Spiritful",
    id: 80,
    creator: "Zinoob",
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Toxix",
    creator: "Kltter",
    midT: 41,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Spec Ops",
    id: 131,
    creator: "floatingpoint",
    weapon: 1,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Retro-cade",
    id: 113,
    creator: "Kltter",
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Incognito",
    midT: 42,
    creator: "cimota",
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Crator",
    id: 132,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Scalar",
    creator: "floatingpoint",
    midT: 43,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 3,
    seas: 2,
  },
  {
    name: "HotRod",
    creator: "Kltter",
    midT: 44,
    glow: true,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Insanity",
    id: 119,
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Violet",
    id: 133,
    creator: "Jhonxay_Playz",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Savaged",
    id: 134,
    creator: "Vx Bomb",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Crimson",
    id: 120,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "T3CH",
    id: 114,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "SMG Wired",
    id: 115,
    creator: "floatingpoint",
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "AWM Federation",
    id: 135,
    creator: "jonschmiddy",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Soul",
    id: 121,
    creator: "Zino",
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "RevBG",
    id: 82,
    creator: "cimota",
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Thunder Serpent",
    midT: 0,
    glow: true,
    noMuz: true,
    mid: 0,
    weapon: 3,
    spnScl: 1.3,
    scl: 0.9,
    mScl: 0.84,
    zOff: 0,
    yOff: 0,
    rarity: 4,
    seas: 2,
  },
  {
    name: "Sheikah",
    id: 136,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Fairy",
    id: 137,
    creator: "Jhonxay",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Trix",
    id: 83,
    creator: "Jhonxay",
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Moonlight",
    creator: "FlowerKid",
    midT: 46,
    glow: true,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 4,
    seas: 2,
  },
  {
    name: "Cassette",
    id: 116,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Damascus",
    id: 122,
    weapon: 2,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Toxic Nitro",
    id: 138,
    creator: "Kltter",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Polly",
    id: 139,
    creator: "Waldo",
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Nozomu",
    id: 140,
    creator: "Jhonxay",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Gilded",
    id: 123,
    creator: "Cimota",
    weapon: 2,
    rarity: 2,
    glow: true,
    seas: 2,
  },
  {
    name: "Shinto",
    id: 124,
    creator: "Kltter",
    weapon: 2,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Lantern",
    id: 125,
    creator: "FlowerKid",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Diode",
    id: 126,
    creator: "Cimota",
    pulsT: 0.0015,
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Automatis",
    id: 24,
    type: 2,
    keyW: "Back",
    scl: 4.5,
    sclMlt: 3.1,
    spnSpd: 0.1,
    xOff: -3,
    sitOff: -0.9,
    sitOffZ: -0.2,
    yOff: -0.5,
    rarity: 4,
    seas: 2,
    rAnim: 0.0015,
    rAnimA: "x",
  },
  {
    name: "Osiris' Servant",
    midT: 1,
    glow: true,
    minGlo: 0.35,
    noMuz: true,
    mid: 0,
    weapon: 3,
    pulsT: 0.0015,
    spnScl: 1.3,
    scl: 0.9,
    mScl: 0.84,
    zOff: 0,
    yOff: 0,
    rarity: 5,
    seas: 2,
  },
  {
    name: "Shatter Wings",
    id: 16,
    tex: 2,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Back",
    seas: 2,
    scl: 3,
    sclMlt: 3,
    sitOff: -0.5,
    sitOffZ: -2,
    xOff: -2,
    yOff: -3,
    movT: 0.0003,
  },
  {
    name: "Shattercore",
    creator: "Xorn XII",
    tex: "weapons/pat/7",
    pat: 7,
    tileS: 3,
    sameGlow: true,
    movT: -0.0007,
    seas: 2,
    weapon: 1,
    rarity: 5,
  },
  {
    name: "Outrunner",
    creator: "Kltter",
    id: 128,
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 2,
  },
  {
    name: "Draconic",
    creator: "Wolfgang",
    id: 129,
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Orchid Dream",
    creator: "Nxbulah",
    id: 84,
    weapon: 5,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Hades",
    creator: "Kltter",
    id: 85,
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 2,
  },
  {
    name: "Aurum",
    id: 86,
    weapon: 5,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Injection",
    creator: "Cimota",
    id: 74,
    weapon: 7,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 2,
  },
  {
    name: "Sugarbear",
    id: 2,
    shirtCol: 15956900,
    sleeveCol: 15956900,
    pantsCol: 15956900,
    shoeCol: 15956900,
    seas: 2,
    type: 5,
    rarity: 4,
  },
  {
    name: "Verb",
    id: 141,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 4,
    glow: true,
    minGlo: 0.35,
    pulsT: 0.0015,
    seas: 2,
  },
  {
    name: "Easter Egg",
    limT: "Easter",
    keyW: "Sprays",
    id: 60,
    type: 4,
    rarity: 1,
    seas: 2,
    opacity: 0.75,
  },
  {
    name: "Egginald",
    limT: "Easter",
    keyW: "Sprays",
    id: 61,
    type: 4,
    rarity: 2,
    seas: 2,
    opacity: 0.75,
  },
  {
    name: "Mr Carrot",
    limT: "Easter",
    keyW: "Sprays",
    id: 62,
    type: 4,
    rarity: 2,
    seas: 2,
    opacity: 0.85,
    frames: 2,
    frameT: 550,
  },
  {
    name: "Carambit",
    limT: "Easter",
    keyW: "Knife",
    id: 8,
    type: 3,
    seas: 2,
    rarity: 4,
    scl: 2,
    sclMlt: 0.76,
    xOff: -0.5,
    yOff: -2,
  },
  {
    name: "Carrot Top",
    limT: "Easter",
    keyW: "Hat",
    id: 61,
    rarity: 2,
    type: 1,
    seas: 2,
    sclMlt: 0.8,
    sitOff: 0.55,
    scl: 1.6,
  },
  {
    name: "Mr Chick",
    limT: "Easter",
    keyW: "Hat",
    id: 62,
    rarity: 2,
    type: 1,
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.8,
    xOff: 0.8,
    scl: 1.6,
  },
  {
    name: "Bunny",
    limT: "Easter",
    keyW: "Hat",
    id: 63,
    rarity: 2,
    type: 1,
    seas: 2,
    sclMlt: 0.89,
    sitOff: 0.8,
    scl: 1.6,
    yOff: -1,
  },
  {
    name: "Munchie",
    limT: "Easter",
    keyW: "Hat",
    id: 64,
    rarity: 1,
    type: 1,
    seas: 2,
    sclMlt: 0.5,
    sitOff: 1.6,
    sitOffZ: 1,
    scl: 1.6,
  },
  {
    name: "Arrowhead",
    limT: "Easter",
    keyW: "Hat",
    id: 65,
    rarity: 1,
    type: 1,
    seas: 2,
    sclMlt: 0.5,
    sitOff: 1,
    scl: 1.6,
    yOff: -2,
  },
  {
    name: "Egghead",
    limT: "Easter",
    keyW: "Hat",
    id: 66,
    rarity: 1,
    type: 1,
    seas: 2,
    sclMlt: 0.7,
    sitOff: 0.79,
    scl: 1.6,
  },
  {
    name: "Egg Basket",
    limT: "Easter",
    keyW: "Back",
    id: 25,
    rarity: 2,
    type: 2,
    seas: 2,
    scl: 3,
    sclMlt: 2,
    sitOff: -0.8,
    sitOffZ: -0.63,
    xOff: -1,
    yOff: -0.8,
    xRot: Math.PI,
  },
  {
    name: "Red Ribbon",
    limT: "Easter",
    keyW: "Back",
    id: 26,
    rarity: 3,
    type: 2,
    seas: 2,
    scl: 3,
    sclMlt: 2,
    sitOff: -1.4,
    sitOffZ: -0.63,
    xOff: -2,
  },
  {
    name: "Carockets",
    limT: "Easter",
    keyW: "Back",
    id: 27,
    rarity: 3,
    type: 2,
    seas: 2,
    scl: 3,
    sclMlt: 2,
    sitOff: -0.9,
    sitOffZ: -0.63,
    xOff: -0.7,
    xRot: Math.PI,
  },
  {
    name: "Carrot Blades",
    limT: "Easter",
    keyW: "Back",
    id: 28,
    rarity: 3,
    type: 2,
    seas: 2,
    scl: 3,
    sclMlt: 2,
    sitOff: -0.9,
    sitOffZ: -0.3,
    xOff: -0.4,
    yOff: -0.6,
    xRot: Math.PI,
  },
  {
    name: "Chick N' Basket",
    limT: "Easter",
    keyW: "Back",
    id: 29,
    rarity: 3,
    type: 2,
    seas: 2,
    scl: 3,
    sclMlt: 2,
    sitOff: -1.1,
    sitOffZ: -0.63,
    xOff: -1,
    xRot: Math.PI,
  },
  {
    name: "Just N' Egg",
    limT: "Easter",
    keyW: "Back",
    id: 30,
    rarity: 1,
    type: 2,
    seas: 2,
    scl: 3,
    sclMlt: 2.5,
    sitOff: -0.5,
    sitOffZ: -0.63,
    xOff: -1,
    xRot: Math.PI,
  },
  {
    name: "Egg Tamer",
    limT: "Easter",
    keyW: "Back",
    id: 31,
    type: 2,
    scl: 3,
    sclMlt: 2.6,
    sitOff: -1.1,
    sitOffZ: -2,
    yOff: -0.9,
    xOff: -0.3,
    rarity: 5,
    seas: 2,
    rAnim: 0.0015,
    rAnimA: "x",
  },
  {
    name: "Carotine",
    limT: "Easter",
    id: 3,
    shirtCol: 13203507,
    sleeveCol: 3911758,
    pantsCol: 13203507,
    shoeCol: 3911758,
    seas: 2,
    type: 5,
    rarity: 4,
  },
  {
    name: "Zig-Zag",
    limT: "Easter",
    id: 142,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Eco",
    limT: "Easter",
    id: 143,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Musk",
    limT: "Easter",
    id: 144,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sugar Kiss",
    limT: "Easter",
    id: 145,
    weapon: 1,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Candy",
    limT: "Easter",
    id: 146,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Choc",
    limT: "Easter",
    id: 147,
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Pastel",
    limT: "Easter",
    id: 148,
    creator: "Jonschmiddy",
    weapon: 1,
    rarity: 2,
    seas: 2,
  },
  {
    name: "BunnyBeam",
    limT: "Easter",
    id: 149,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 2,
  },
  {
    name: "Zig-Zag",
    limT: "Easter",
    id: 130,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Eco",
    limT: "Easter",
    id: 131,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Musk",
    limT: "Easter",
    id: 132,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sugar Kiss",
    limT: "Easter",
    id: 133,
    weapon: 2,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Candy",
    limT: "Easter",
    id: 134,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Wiggle",
    limT: "Easter",
    id: 135,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Choc",
    limT: "Easter",
    id: 136,
    weapon: 2,
    rarity: 2,
    seas: 2,
  },
  {
    name: "HyperYolk",
    limT: "Easter",
    id: 137,
    creator: "FlowerKid",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 2,
  },
  {
    name: "Farmland",
    limT: "Easter",
    id: 138,
    creator: "Cimota",
    weapon: 2,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Horisun",
    limT: "Easter",
    id: 139,
    creator: "Cimota",
    weapon: 2,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 2,
  },
  {
    name: "Zig-Zag",
    limT: "Easter",
    id: 117,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Eco",
    limT: "Easter",
    id: 118,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Musk",
    limT: "Easter",
    id: 119,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sugar Kiss",
    limT: "Easter",
    id: 120,
    weapon: 4,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Candy",
    limT: "Easter",
    id: 121,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Wiggle",
    limT: "Easter",
    id: 122,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Choc",
    limT: "Easter",
    id: 123,
    weapon: 4,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Festive",
    limT: "Easter",
    id: 124,
    creator: "FlowerKid",
    weapon: 4,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Zig-Zag",
    limT: "Easter",
    midT: 47,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Eco",
    limT: "Easter",
    midT: 48,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Musk",
    limT: "Easter",
    midT: 49,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sugar Kiss",
    limT: "Easter",
    midT: 50,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Candy",
    limT: "Easter",
    midT: 51,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Egg Catcher",
    limT: "Easter",
    creator: "FlowerKid",
    midT: 52,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Eggcellent",
    limT: "Easter",
    creator: "Cimota",
    midT: 53,
    glow: true,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 3,
    seas: 2,
  },
  {
    name: "Zig-Zag",
    limT: "Easter",
    id: 75,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Eco",
    limT: "Easter",
    id: 76,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Musk",
    limT: "Easter",
    id: 77,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Sugar Kiss",
    limT: "Easter",
    id: 78,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Candy",
    limT: "Easter",
    id: 79,
    weapon: 7,
    rarity: 1,
    seas: 2,
  },
  {
    name: "Choc",
    limT: "Easter",
    id: 80,
    weapon: 7,
    rarity: 2,
    seas: 2,
  },
  {
    name: "Sweet Tooth",
    keyW: "Knife",
    limT: "Easter",
    creator: "jonschmiddy",
    flipAnim: true,
    id: 3,
    tex: 6,
    type: 3,
    scl: 2.6,
    seas: 2,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 4,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Ceretta 92",
    limT: "Easter",
    midT: 2,
    noMuz: true,
    noEmis: true,
    mid: 2,
    weapon: 3,
    spnScl: 1.3,
    scl: 0.9,
    mScl: 0.84,
    zOff: 0,
    yOff: 0,
    rarity: 5,
    seas: 2,
  },
  {
    name: "Gold N' Egg",
    limT: "Easter",
    keyW: "Back",
    tex: 1,
    id: 30,
    rarity: 4,
    type: 2,
    seas: 2,
    scl: 3,
    sclMlt: 2.5,
    sitOff: -0.5,
    sitOffZ: -0.63,
    xOff: -1,
    xRot: Math.PI,
  },
  {
    name: "Vertigo",
    limT: "Easter",
    keyW: "Hat",
    id: 67,
    rarity: 6,
    type: 1,
    seas: 2,
    sclMlt: 0.9,
    sitOff: -0.8,
    scl: 1.6,
    rAnim: -0.0022,
    rAnimA: "y",
  },
  {
    name: "U.F.0",
    keyW: "Hat",
    id: 68,
    rarity: 5,
    type: 1,
    seas: 2,
    sclMlt: 1.75,
    sitOff: -0.5,
    xOff: -3.6,
    scl: 1.6,
    rAnim: -0.0022,
    rAnimA: "y",
    trans: true,
    glow: true,
  },
  {
    name: "RGB",
    priceMlt: 4,
    id: 4,
    seas: 2,
    type: 5,
    rarity: 6,
    rgb: true,
    rgbS: 0.5,
  },
  {
    name: "Raynb0w",
    weapon: 3,
    pat: 1,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    rarity: 5,
    seas: 2,
  },
  {
    name: "Hackusate",
    mid: 0,
    midT: 41,
    weapon: 10,
    rarity: 5,
    rgb: true,
    rgbs: 0.5,
    wire: true,
    seas: 3,
  },
  {
    name: "Raynb0w",
    creator: "???",
    pat: 1,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    weapon: 15,
    rarity: 5,
    seas: 3,
  },
  {
    name: "Raynb0w",
    creator: "???",
    pat: 1,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    weapon: 14,
    rarity: 5,
    seas: 3,
  },
  {
    name: "Coldsnap",
    id: 9,
    shirtCol: 2862847,
    sleeveCol: 16449023,
    pantsCol: 2862847,
    shoeCol: 16449023,
    seas: 3,
    type: 5,
    rarity: 4,
  },
  {
    name: "Crimson",
    id: 5,
    shirtCol: 16724787,
    sleeveCol: 526344,
    pantsCol: 16724787,
    shoeCol: 526344,
    seas: 3,
    type: 5,
    rarity: 4,
  },
  {
    name: "Lavender",
    id: 6,
    shirtCol: 11809791,
    sleeveCol: 6501375,
    pantsCol: 11809791,
    shoeCol: 6501375,
    seas: 3,
    type: 5,
    rarity: 4,
  },
  {
    name: "Royality",
    id: 150,
    creator: "Nxbulah",
    weapon: 1,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Firestorm",
    id: 151,
    creator: "Chromatikk",
    weapon: 1,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Sense",
    id: 152,
    creator: "Nxbulah",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "YÃ¼rei",
    id: 153,
    creator: "Jhonxay",
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Unistorm",
    id: 154,
    creator: "Skriller33",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Vaporride",
    id: 155,
    creator: "jonschmiddy",
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Alligator",
    id: 156,
    creator: "Skriller33",
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Hakan",
    id: 157,
    creator: "Nxbulah & Kilfy",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Jungle",
    id: 158,
    creator: "Skriller33",
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Void X",
    id: 159,
    creator: "floatingpoint",
    glow: true,
    weapon: 1,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Eira",
    id: 160,
    creator: "Nxbulah",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Neigh",
    id: 161,
    creator: "_irizu",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Akkoro",
    id: 162,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Stickerbomb",
    id: 163,
    creator: "Luminae",
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Combined",
    id: 164,
    creator: "Kltter",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Wildstyle",
    id: 165,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Nova",
    id: 166,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "The Star",
    id: 167,
    creator: "Chromatikk",
    weapon: 1,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Lime",
    id: 168,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    id: 169,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    id: 170,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    id: 171,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    id: 172,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    id: 173,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    id: 174,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    id: 175,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    id: 176,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    id: 177,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    id: 178,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    id: 179,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    id: 180,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    id: 181,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    id: 182,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    id: 183,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    id: 184,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    id: 185,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    id: 186,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    id: 187,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    id: 188,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    id: 189,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    id: 190,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    id: 191,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    id: 192,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    id: 193,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    id: 194,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    id: 195,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    id: 196,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    id: 197,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    id: 198,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    id: 199,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    id: 200,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    id: 201,
    weapon: 1,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    id: 202,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Sagittarius",
    id: 140,
    creator: "Chromatikk",
    weapon: 2,
    rarity: 4,
    seas: 3,
  },
  {
    name: "VAX",
    id: 141,
    creator: "KItter",
    weapon: 2,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Wims",
    id: 142,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Amaterasu",
    id: 143,
    creator: "KItter",
    weapon: 2,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Kanagawa",
    id: 144,
    creator: "FlowerKid",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "AKS",
    id: 145,
    creator: "KItter",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Fragternity",
    id: 146,
    creator: "FlowerKid",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Eurasian",
    id: 147,
    creator: "Cimota",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Ifrit",
    id: 148,
    creator: "FlowerKid",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Fantasy",
    id: 149,
    creator: "Luminae",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Apocalypse",
    id: 150,
    creator: "Lxckless",
    weapon: 2,
    rarity: 5,
    glow: true,
    seas: 3,
  },
  {
    name: "Cheetah",
    id: 151,
    creator: "Skriller33",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Krunkodore",
    id: 152,
    creator: "KItter",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Creature",
    id: 153,
    creator: "Jonschmiddy",
    weapon: 2,
    rarity: 3,
    frames: 4,
    frameT: 250,
    seas: 3,
  },
  {
    name: "Disco",
    id: 154,
    creator: "Cimota",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Komics",
    id: 155,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Toxic Nitro",
    id: 156,
    creator: "KItter",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Swarm",
    id: 157,
    creator: "Kilfy",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Letos",
    id: 159,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Machinehead",
    id: 160,
    creator: "jonschmiddy",
    weapon: 2,
    rarity: 4,
    frames: 4,
    frameT: 100,
    seas: 3,
  },
  {
    name: "Atheris",
    id: 161,
    creator: "Skriller33",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Akhenaten",
    id: 162,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Futuristic",
    id: 163,
    creator: "Zinoob",
    weapon: 2,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Raiju",
    id: 164,
    creator: "Kilfy",
    weapon: 2,
    rarity: 5,
    glow: true,
    seas: 3,
  },
  {
    name: "Plague",
    id: 165,
    creator: "BigBBaniel",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Frostywolf",
    id: 166,
    creator: "Skriller33",
    weapon: 2,
    rarity: 4,
    glow: true,
    frames: 2,
    frameT: 250,
    seas: 3,
  },
  {
    name: "Abducted",
    id: 167,
    creator: "Luminae",
    weapon: 2,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Lime",
    id: 168,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    id: 169,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    id: 170,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    id: 171,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    id: 172,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    id: 173,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    id: 174,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    id: 175,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    id: 176,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    id: 177,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    id: 178,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    id: 179,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    id: 180,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    id: 181,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    id: 182,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    id: 183,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    id: 184,
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    id: 185,
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    id: 186,
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    id: 187,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    id: 188,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    id: 189,
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    id: 190,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    id: 191,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    id: 192,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    id: 193,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    id: 194,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    id: 195,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    id: 196,
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    id: 197,
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    id: 198,
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    id: 199,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    id: 200,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    id: 201,
    weapon: 2,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    id: 202,
    weapon: 2,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquarium",
    id: 125,
    creator: "Skriller33",
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Traveller",
    id: 126,
    creator: "KItter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Abraxas",
    id: 127,
    creator: "Cimota",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Krunkstruct",
    id: 128,
    creator: "Cimota",
    weapon: 4,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Bloodmoon",
    id: 129,
    creator: "Nxbulah",
    weapon: 4,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Doodle",
    id: 130,
    creator: "Luminae",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "WildClaw",
    id: 131,
    creator: "FlowerKid",
    weapon: 4,
    rarity: 5,
    glow: true,
    seas: 3,
  },
  {
    name: "Carcinogen",
    id: 132,
    creator: "Floatingpoint",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Spinner",
    id: 133,
    creator: "Cimota",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Green Waves",
    id: 134,
    creator: "Zinoob",
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Purple Waves",
    id: 135,
    creator: "Zinoob",
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Goddess",
    id: 136,
    creator: "FlowerKid",
    weapon: 4,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Bahamut",
    id: 137,
    creator: "Kilfy",
    weapon: 4,
    rarity: 5,
    glow: true,
    seas: 3,
  },
  {
    name: "Occult",
    id: 138,
    creator: "floatingpoint",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Merlin",
    id: 139,
    creator: "Cimota",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Kittle",
    id: 140,
    creator: "Kltter",
    weapon: 4,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "TV Strike",
    id: 141,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Composite",
    id: 142,
    creator: "Floatingpoint",
    weapon: 4,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Taurine",
    id: 143,
    creator: "Chromatikk",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Vandal",
    id: 144,
    creator: "Nxbulah",
    weapon: 4,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Amethyst",
    id: 145,
    creator: "Luminae",
    weapon: 4,
    rarity: 3,
    frames: 4,
    frameT: 250,
    seas: 3,
  },
  {
    name: "Northern",
    id: 146,
    creator: "Luminae",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Agent",
    id: 147,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Lester",
    id: 148,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Lime",
    id: 149,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    id: 150,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    id: 151,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    id: 152,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    id: 153,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    id: 154,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    id: 155,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    id: 156,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    id: 157,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    id: 158,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    id: 159,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    id: 160,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    id: 161,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    id: 162,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    id: 163,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    id: 164,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    id: 165,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    id: 166,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    id: 167,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    id: 168,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    id: 169,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    id: 170,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    id: 171,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    id: 172,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    id: 173,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    id: 174,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    id: 175,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    id: 176,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    id: 177,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    id: 178,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    id: 179,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    id: 180,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    id: 181,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    id: 182,
    weapon: 4,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    id: 183,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Lineride",
    midT: 54,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    pulsT: 0.0015,
    creator: "Kltter",
    weapon: 6,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Halogen",
    midT: 55,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "floatingpoint",
    weapon: 6,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Adventurine",
    midT: 56,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Nxbulah",
    weapon: 6,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Surreal",
    midT: 57,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Nxbulah",
    weapon: 6,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Red Supersport",
    midT: 58,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Kltter",
    weapon: 6,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Pink Supersport",
    midT: 59,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Kltter",
    weapon: 6,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Exponentiat",
    midT: 60,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Cimota",
    glow: true,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Ethereal",
    midT: 61,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Nxbulah",
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Spectate",
    midT: 62,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Cimota",
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Sunburst",
    midT: 63,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "FlowerKid",
    weapon: 6,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Hydrofluric",
    midT: 64,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Cimota",
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Mech Rainbow",
    midT: 65,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Luminae",
    weapon: 6,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Midnight",
    midT: 66,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    creator: "Luminae",
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Lime",
    midT: 67,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    midT: 68,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    midT: 69,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    midT: 70,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    midT: 71,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    midT: 72,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    midT: 73,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    midT: 74,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    midT: 75,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    midT: 76,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    midT: 77,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    midT: 78,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    midT: 79,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    midT: 80,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    midT: 81,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    midT: 82,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    midT: 83,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    midT: 84,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    midT: 85,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    midT: 86,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    midT: 87,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    midT: 88,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    midT: 89,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    midT: 90,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    midT: 91,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    midT: 92,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    midT: 93,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    midT: 94,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    midT: 95,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    midT: 96,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    midT: 97,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    midT: 98,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    midT: 99,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    midT: 100,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    midT: 101,
    mid: 0,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Excalibur",
    id: 87,
    creator: "Nxbulah",
    weapon: 5,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Zeus",
    id: 88,
    creator: "Kltter",
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Luminous",
    id: 89,
    creator: "Nxbulah",
    weapon: 5,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Depth",
    id: 90,
    creator: "jonschmiddy",
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Absinthe",
    id: 91,
    creator: "Cimota",
    weapon: 5,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Scoria",
    id: 92,
    creator: "Cimota",
    weapon: 5,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Krunkitis",
    id: 93,
    creator: "Electrode_",
    weapon: 5,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Pearlescent",
    id: 94,
    creator: "Cimota",
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Zap",
    id: 95,
    creator: "Kilfy",
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Midas",
    id: 96,
    creator: "FlowerKid",
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Sea Wanderer",
    id: 97,
    creator: "Nxbulah",
    weapon: 5,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Crystallize",
    id: 98,
    creator: "Cimota",
    weapon: 5,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Lime",
    id: 99,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    id: 100,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    id: 101,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    id: 102,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    id: 103,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    id: 104,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    id: 105,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    id: 106,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    id: 107,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    id: 108,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    id: 109,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    id: 110,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    id: 111,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    id: 112,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    id: 113,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    id: 114,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    id: 115,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    id: 116,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    id: 117,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    id: 118,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    id: 119,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    id: 120,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    id: 121,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    id: 122,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    id: 123,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    id: 124,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    id: 125,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    id: 126,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    id: 127,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    id: 128,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    id: 129,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    id: 130,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    id: 131,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    id: 132,
    weapon: 5,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    id: 133,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Playmat",
    creator: "Skriller33",
    id: 67,
    rarity: 4,
    type: 4,
    frames: 4,
    frameT: 250,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Anti-cheat",
    creator: "Bodeneinheit",
    id: 68,
    rarity: 4,
    type: 4,
    frames: 4,
    frameT: 450,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Vince OP",
    creator: "Bodeneinheit",
    id: 69,
    rarity: 2,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "200 IQ",
    creator: "krunchiez",
    id: 70,
    rarity: 1,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Alien",
    creator: "MBR7CLeo",
    id: 71,
    rarity: 1,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Krunkitis",
    creator: "NvrRshABlyat",
    id: 72,
    rarity: 2,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "SMH",
    creator: "OneEyedOwl",
    id: 73,
    rarity: 1,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Race",
    creator: "ReDeagle",
    id: 74,
    rarity: 1,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Fair Trades",
    creator: "Seasefire",
    id: 75,
    rarity: 2,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Lucky",
    creator: "TrGPoTaTo",
    id: 76,
    rarity: 0,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Arrow",
    creator: "TrGPoTaTo",
    id: 77,
    rarity: 0,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Dream",
    creator: "Nxbulah",
    id: 78,
    rarity: 3,
    type: 4,
    keyW: "Spray",
    seas: 3,
  },
  {
    name: "Sonar",
    id: 81,
    creator: "Cimota",
    weapon: 7,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Icevein",
    id: 82,
    creator: "FlowerKid",
    weapon: 7,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Demonvein",
    id: 83,
    creator: "FlowerKid",
    weapon: 7,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Tartrazine",
    id: 84,
    creator: "Cimota",
    weapon: 7,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Diopside",
    id: 85,
    creator: "Cimota",
    weapon: 7,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Lime",
    id: 86,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    id: 87,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    id: 88,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    id: 89,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    id: 90,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    id: 91,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    id: 92,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    id: 93,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    id: 94,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    id: 95,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    id: 96,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    id: 97,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    id: 98,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    id: 99,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    id: 100,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    id: 101,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    id: 102,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    id: 103,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    id: 104,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    id: 105,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    id: 106,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    id: 107,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    id: 108,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    id: 109,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    id: 110,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    id: 111,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    id: 112,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    id: 113,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    id: 114,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    id: 115,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    id: 116,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    id: 117,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    id: 118,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    id: 119,
    weapon: 7,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    id: 120,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Ballistic Knife",
    id: 9,
    rarity: 4,
    type: 3,
    sxOff: 0.4,
    scl: 1.4,
    yOff: -2,
    keyW: "Melee",
    seas: 3,
  },
  {
    name: "Samurai Sword",
    id: 10,
    rarity: 4,
    type: 3,
    sxRot: -0.3,
    syOff: 0.1,
    szOff: -0.1,
    scl: 0.8,
    yOff: -1,
    xOff: -1,
    keyW: "Melee",
    seas: 3,
  },
  {
    name: "Acid Razer",
    id: 11,
    rarity: 5,
    type: 3,
    sxOff: 0.02,
    sclMlt: 1.1,
    scl: 2,
    yOff: -2,
    glow: true,
    pulsT: 0.1,
    keyW: "Melee",
    seas: 3,
  },
  {
    name: "Lumus",
    tex: 1,
    id: 11,
    rarity: 5,
    sxOff: 0.02,
    sclMlt: 1.1,
    glow: true,
    scl: 2,
    yOff: -2,
    pulsT: 0.1,
    type: 3,
    keyW: "Melee",
    seas: 3,
  },
  {
    name: "Heated Crowbar",
    id: 12,
    rarity: 5,
    type: 3,
    scl: 0.8,
    yOff: -1,
    xOff: -0.5,
    keyW: "Melee",
    glow: true,
    pulsT: 0.0015,
    seas: 3,
    snd: true,
  },
  {
    name: "Disintegrator",
    mid: 0,
    glow: true,
    limited: true,
    pulsT: 0.03,
    seas: 3,
    weapon: 2,
    rarity: 6,
  },
  {
    name: "Artifact XY",
    id: 0,
    weapon: 12,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Anti-Matter",
    mid: 4,
    glow: true,
    limited: true,
    pulsT: 0.0015,
    scl: 0.9,
    mScl: 1,
    spnScl: 1.35,
    zOff: -0.25,
    seas: 3,
    yOff: 0.05,
    weapon: 1,
    rarity: 6,
  },
  {
    name: "Good Ol' Days",
    mid: 3,
    pulsT: 0.0015,
    scl: 0.9,
    mScl: 1,
    spnScl: 1.35,
    zOff: -0.25,
    seas: 3,
    yOff: 0.05,
    weapon: 1,
    rarity: 5,
  },
  {
    name: "Blonde Beard",
    id: 69,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Brown Beard",
    tex: 1,
    id: 69,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Aged Beard",
    id: 70,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Bandito",
    id: 71,
    rarity: 4,
    glow: true,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Purple Beanie",
    id: 72,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Red Beanie",
    tex: 1,
    id: 72,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Blue Pom-Pom",
    id: 73,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Green Pom-Pom",
    tex: 1,
    id: 73,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Love-Cap",
    id: 74,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1.5,
    xOff: 1,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Lucky-Cap",
    tex: 1,
    id: 74,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    xOff: -1,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Chef",
    id: 75,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Hypno",
    id: 76,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Hotdogger",
    id: 77,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    noHead: true,
    sclMlt: 0.7,
    sitOff: 0.71,
    seas: 3,
  },
  {
    name: "Sunflower",
    id: 78,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Lavender",
    tex: 1,
    id: 78,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Cirangle",
    id: 79,
    rarity: 3,
    glow: true,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -4,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Django",
    id: 80,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Cattleman",
    tex: 1,
    id: 80,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Chosen One",
    id: 81,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    yOff: -1,
    sclMlt: 0.62,
    sitOff: -0.35,
    rAnim: -0.004,
    rAnimA: "y",
    seas: 3,
  },
  {
    name: "Sailor",
    id: 82,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Planetarium",
    id: 83,
    rarity: 5,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: -0.68,
    rAnim: -0.0016,
    rAnimA: "y",
    seas: 3,
  },
  {
    name: "Acid Reaper",
    id: 84,
    rarity: 4,
    glow: true,
    noHead: true,
    type: 1,
    keyW: "Hat",
    xOff: 0.5,
    yOff: -0.5,
    sclMlt: 0.5,
    sitOff: 1.05,
    seas: 3,
  },
  {
    name: "Ushanka",
    id: 85,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Private",
    id: 86,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Sergeant",
    id: 87,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Undead",
    id: 88,
    rarity: 4,
    glow: true,
    noHead: true,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Witch",
    id: 89,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    sclMlt: 0.5,
    xOff: 1,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Farmer",
    id: 90,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    yOff: -1,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Helper",
    tex: 1,
    id: 90,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    yOff: -1,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Purple Bandana",
    id: 91,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Red Bandana",
    tex: 1,
    id: 91,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Rave Glasses",
    id: 92,
    rarity: 3,
    glow: true,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    spnScl: 1.6,
    xOff: 2,
    yOff: -2,
    sitOff: 1,
    seas: 3,
  },
  {
    name: "Blue Headband",
    id: 93,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1,
    sitOff: 1,
    seas: 3,
  },
  {
    name: "Red Headband",
    tex: 1,
    id: 93,
    rarity: 0,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1,
    sitOff: 1,
    seas: 3,
  },
  {
    name: "Shlem",
    id: 94,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1,
    sitOff: 0.9,
    seas: 3,
  },
  {
    name: "Headshot",
    id: 95,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    // yOff: -1,
    sitOff: 0.9,
    xOff: 0.5,
    yOff: -1,
    seas: 3,
  },
  {
    name: "Big Apple",
    id: 96,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    noHead: true,
    sclMlt: 0.56,
    sitOff: 0.75,
    seas: 3,
  },
  {
    name: "Green Alien",
    id: 97,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    noHead: true,
    sclMlt: 0.65,
    spnScl: 1.2,
    sitOff: 0.62,
    seas: 3,
  },
  {
    name: "Purple Alien",
    tex: 1,
    id: 97,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    noHead: true,
    sclMlt: 0.65,
    spnScl: 1.2,
    sitOff: 0.62,
    seas: 3,
  },
  {
    name: "Banananana",
    id: 98,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    noHead: true,
    sclMlt: 0.6,
    sitOff: 0.71,
    seas: 3,
  },
  {
    name: "Coolman",
    id: 99,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    noHead: true,
    sclMlt: 0.56,
    sitOff: 0.75,
    seas: 3,
  },
  {
    name: "Green Headset",
    id: 100,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    yOff: -1.5,
    sitOff: 0.9,
    seas: 3,
  },
  {
    name: "Red Headset",
    tex: 1,
    id: 100,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    sclMlt: 0.5,
    sitOff: 0.9,
    seas: 3,
  },
  {
    name: "Bot 1",
    id: 101,
    rarity: 4,
    glow: true,
    frames: 4,
    frameT: 250,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.9,
    seas: 3,
  },
  {
    name: "Mustache",
    id: 102,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    spnScl: 1.4,
    yOff: -1,
    xOff: 3,
    sitOff: 0.9,
    seas: 3,
  },
  {
    name: "Bane",
    id: 103,
    rarity: 3,
    glow: true,
    type: 1,
    keyW: "Hat",
    yOff: -1,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Ducky",
    id: 104,
    rarity: 2,
    type: 1,
    noHead: true,
    keyW: "Hat",
    sclMlt: 0.8,
    spnScl: 1.4,
    xOff: 0.5,
    yOff: -1,
    sitOff: 0.75,
    seas: 3,
  },
  {
    name: "Pot",
    id: 105,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.8,
    xOff: -1.5,
    yOff: -0.5,
    seas: 3,
  },
  {
    name: "Boom Boxer",
    id: 106,
    rarity: 4,
    glow: true,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.6,
    sitOff: 0.8,
    yOff: -1,
    seas: 3,
  },
  {
    name: "Santa",
    id: 107,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.9,
    xOff: -1,
    yOff: -1,
    seas: 3,
  },
  {
    name: "Splinter",
    id: 108,
    rarity: 4,
    glow: true,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.7,
    seas: 3,
  },
  {
    name: "Wizard",
    id: 109,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.7,
    yOff: -1,
    seas: 3,
  },
  {
    name: "Hackusate",
    id: 203,
    weapon: 2,
    rarity: 5,
    rgb: true,
    rgbs: 0.5,
    wire: true,
    seas: 3,
  },
  {
    name: "Hackusate",
    id: 184,
    weapon: 4,
    rarity: 5,
    rgb: true,
    rgbs: 0.5,
    wire: true,
    seas: 3,
  },
  {
    name: "Hackusate",
    id: 121,
    weapon: 7,
    rarity: 5,
    rgb: true,
    rgbs: 0.5,
    wire: true,
    seas: 3,
  },
  {
    name: "Hackusate",
    id: 74,
    weapon: 9,
    rarity: 5,
    rgb: true,
    rgbs: 0.5,
    wire: true,
    seas: 3,
  },
  {
    name: "Flag",
    id: 32,
    rarity: 1,
    type: 2,
    keyW: "Body",
    sclMlt: 2,
    sitOff: -1.3,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "KrunkBoy",
    id: 33,
    rarity: 3,
    frames: 4,
    frameT: 500,
    type: 2,
    keyW: "Body",
    sclMlt: 2.2,
    spnScl: 4,
    xRot: 2,
    sitOff: -0.7,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Skeleton Grip",
    id: 34,
    rarity: 2,
    type: 2,
    keyW: "Body",
    sclMlt: 2.2,
    spnScl: 2.4,
    sitOff: -0.7,
    sitOffZ: -0.65,
    seas: 3,
  },
  {
    name: "Spider Grip",
    tex: 1,
    id: 34,
    rarity: 2,
    type: 2,
    keyW: "Body",
    sclMlt: 2.2,
    spnScl: 2.4,
    xOff: -1,
    sitOff: -0.7,
    sitOffZ: -0.65,
    seas: 3,
  },
  {
    name: "Sir HotDog",
    id: 35,
    rarity: 2,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    xRot: 2,
    xOff: -1.5,
    yOff: -0.5,
    spnScl: 2.6,
    sitOff: -0.1,
    sitOffZ: -0.65,
    seas: 3,
  },
  {
    name: "Green Kite",
    id: 36,
    rarity: 0,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    sitOff: -1.1,
    sitOffZ: -0.65,
    seas: 3,
  },
  {
    name: "Lantern",
    id: 37,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    type: 2,
    keyW: "Body",
    sclMlt: 2.6,
    spnScl: 3.4,
    yOff: 0.5,
    xOff: -3,
    xRot: 2,
    sitOff: -0.75,
    sitOffZ: -0.75,
    seas: 3,
  },
  {
    name: "Hellbound",
    id: 38,
    rarity: 3,
    glow: true,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: -3,
    yOff: -1,
    sitOff: -1.1,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Nuke",
    id: 39,
    rarity: 3,
    glow: true,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 3,
    xOff: -3,
    xRot: 2,
    sitOff: -1.1,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Roman Shield",
    id: 40,
    rarity: 2,
    type: 2,
    keyW: "Body",
    sclMlt: 2.6,
    spnScl: 2.6,
    xOff: -2,
    xRot: 2,
    sitOff: -0.85,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Krunky Safe",
    id: 41,
    rarity: 1,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xRot: 2,
    xOff: -2,
    sitOff: -1.1,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Yellow Scuba",
    id: 43,
    rarity: 1,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    sitOff: -1.1,
    sitOffZ: -0.6,
    xOff: -2,
    seas: 3,
  },
  {
    name: "Blue Scuba",
    tex: 1,
    id: 43,
    rarity: 1,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    sitOff: -1.1,
    sitOffZ: -0.6,
    xOff: -2,
    seas: 3,
  },
  {
    name: "Agares",
    id: 44,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Body",
    sclMlt: 2.2,
    spnScl: 2.4,
    xOff: -1,
    zOff: 1,
    sitOff: -0.9,
    sitOffZ: -0.6,
    trans: true,
    seas: 3,
  },
  {
    name: "Red Ski",
    id: 45,
    rarity: 1,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: -1,
    sitOff: -0.9,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Green Ski",
    tex: 1,
    id: 45,
    rarity: 1,
    type: 2,
    keyW: "Body",
    spnScl: 2.6,
    xOff: -1,
    sclMlt: 2.4,
    sitOff: -0.9,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Black Widow",
    id: 46,
    rarity: 5,
    glow: true,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: 1,
    xRot: 2.5,
    sitOff: -0.9,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Viking",
    id: 48,
    rarity: 3,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: -2,
    zOff: -1,
    xRot: 2,
    sitOff: -0.9,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Kruncade",
    id: 50,
    rarity: 3,
    frames: 2,
    frameT: 250,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    xRot: 2,
    xOff: -1.5,
    yOff: -0.5,
    spnScl: 2.6,
    sitOff: -1,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Fully Loaded",
    id: 51,
    rarity: 3,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    sitOff: -1.1,
    sitOffZ: -0.6,
    xOff: -2,
    spnScl: 2.6,
    seas: 3,
  },
  {
    name: "1 Year Cape",
    id: 52,
    rarity: 5,
    side: 2,
    glow: true,
    type: 2,
    keyW: "Body",
    xRot: 2,
    xOff: -1,
    yOff: 0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -0.5,
    sitOffZ: -0.6,
    seas: 3,
    noSale: true,
    illicit: true,
    funds: 100,
    reqT: "1 Year Account Age",
    req: function (d) {
      return (
        new Date().getTime() - new Date(d.createDate).getTime() >= 31536000000
      );
    },
  },
  {
    name: "2 Year Cape",
    tex: 1,
    id: 52,
    rarity: 5,
    side: 2,
    glow: true,
    type: 2,
    keyW: "Body",
    xRot: 2,
    xOff: -1,
    yOff: 0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -0.5,
    sitOffZ: -0.6,
    seas: 3,
    noSale: true,
    illicit: true,
    funds: 100,
    reqT: "2 Year Account Age",
    req: function (d) {
      return (
        new Date().getTime() - new Date(d.createDate).getTime() >= 63072000000
      );
    },
  },
  {
    name: "Arunasura",
    id: 53,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Body",
    xOff: -2.5,
    yOff: -2,
    xRot: -0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -0.65,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Barong",
    tex: 1,
    id: 53,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Body",
    xOff: -2.5,
    yOff: -2,
    xRot: -0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -0.65,
    sitOffZ: -0.6,
    seas: 3,
  },
  {
    name: "Pink Glazed",
    id: 54,
    rarity: 0,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: -2,
    sitOff: -0.5,
    sitOffZ: -0.7,
    seas: 3,
  },
  {
    name: "Blue Glazed",
    tex: 1,
    id: 54,
    rarity: 0,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: -2,
    sitOff: -0.5,
    sitOffZ: -0.7,
    seas: 3,
  },
  {
    name: "Krunk-Bull",
    id: 55,
    rarity: 0,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: -2,
    sitOff: -1.4,
    sitOffZ: -0.7,
    seas: 3,
  },
  {
    name: "Soul Reaper",
    tex: 1,
    id: 84,
    rarity: 4,
    glow: true,
    noHead: true,
    type: 1,
    keyW: "Hat",
    xOff: 1,
    yOff: -0.5,
    sclMlt: 0.5,
    sitOff: 1.05,
    seas: 3,
  },
  {
    name: "Terra",
    id: 7,
    shirtCol: 1486651,
    sleeveCol: 1842204,
    pantsCol: 1486651,
    shoeCol: 1842204,
    seas: 3,
    type: 5,
    rarity: 4,
  },
  {
    name: "Amberite",
    id: 8,
    shirtCol: 16765734,
    sleeveCol: 1842204,
    pantsCol: 16765734,
    shoeCol: 1842204,
    seas: 3,
    type: 5,
    rarity: 4,
  },
  {
    name: "Moon Juice",
    id: 205,
    weapon: 1,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Shift",
    mid: 0,
    midT: 2,
    creator: "Luminae",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Lepton",
    mid: 0,
    midT: 3,
    creator: "jonschmiddy",
    weapon: 8,
    rarity: 4,
    pulsT: 0.0015,
    frames: 4,
    frameT: 250,
    seas: 3,
  },
  {
    name: "Dessolate",
    mid: 0,
    midT: 4,
    creator: "Nxbulah",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Retro Beast",
    mid: 0,
    midT: 5,
    creator: "Luminae",
    weapon: 8,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Lime",
    mid: 0,
    midT: 6,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    mid: 0,
    midT: 7,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    mid: 0,
    midT: 8,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    mid: 0,
    midT: 9,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    mid: 0,
    midT: 10,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    mid: 0,
    midT: 11,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    mid: 0,
    midT: 12,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    mid: 0,
    midT: 13,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    mid: 0,
    midT: 14,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    mid: 0,
    midT: 15,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    mid: 0,
    midT: 16,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    mid: 0,
    midT: 17,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    mid: 0,
    midT: 18,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    mid: 0,
    midT: 19,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    mid: 0,
    midT: 20,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    mid: 0,
    midT: 21,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    mid: 0,
    midT: 22,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    mid: 0,
    midT: 23,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    mid: 0,
    midT: 24,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    mid: 0,
    midT: 25,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    mid: 0,
    midT: 26,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    mid: 0,
    midT: 27,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    mid: 0,
    midT: 28,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    mid: 0,
    midT: 29,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    mid: 0,
    midT: 30,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    mid: 0,
    midT: 31,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    mid: 0,
    midT: 32,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    mid: 0,
    midT: 33,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    mid: 0,
    midT: 34,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    mid: 0,
    midT: 35,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    mid: 0,
    midT: 36,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    mid: 0,
    midT: 37,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    mid: 0,
    midT: 38,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    mid: 0,
    midT: 39,
    weapon: 8,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    mid: 0,
    midT: 40,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "StremZ",
    id: 204,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Krystal",
    mid: 0,
    midT: 40,
    creator: "KItter",
    weapon: 10,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Corrosive",
    mid: 0,
    midT: 1,
    creator: "Jonschmiddy",
    weapon: 10,
    rarity: 3,
    frames: 4,
    frameT: 250,
    seas: 3,
  },
  {
    name: "Kitta",
    mid: 0,
    midT: 2,
    creator: "KItter",
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Plasma Grime",
    mid: 0,
    midT: 3,
    creator: "Cimota",
    weapon: 10,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Graffiti",
    mid: 0,
    midT: 4,
    creator: "Maple",
    weapon: 10,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Lime",
    mid: 0,
    midT: 5,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    mid: 0,
    midT: 6,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    mid: 0,
    midT: 7,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    mid: 0,
    midT: 8,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    mid: 0,
    midT: 9,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    mid: 0,
    midT: 10,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    mid: 0,
    midT: 11,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    mid: 0,
    midT: 12,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    mid: 0,
    midT: 13,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    mid: 0,
    midT: 14,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    mid: 0,
    midT: 15,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    mid: 0,
    midT: 16,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    mid: 0,
    midT: 17,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    mid: 0,
    midT: 18,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    mid: 0,
    midT: 19,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    mid: 0,
    midT: 20,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    mid: 0,
    midT: 21,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    mid: 0,
    midT: 22,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    mid: 0,
    midT: 23,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    mid: 0,
    midT: 24,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    mid: 0,
    midT: 25,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    mid: 0,
    midT: 26,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    mid: 0,
    midT: 27,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    mid: 0,
    midT: 28,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    mid: 0,
    midT: 29,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    mid: 0,
    midT: 30,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    mid: 0,
    midT: 31,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    mid: 0,
    midT: 32,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    mid: 0,
    midT: 33,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    mid: 0,
    midT: 34,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    mid: 0,
    midT: 35,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    mid: 0,
    midT: 36,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    mid: 0,
    midT: 37,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    mid: 0,
    midT: 38,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    mid: 0,
    midT: 39,
    weapon: 10,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Fireburst",
    id: 81,
    creator: "jonschmiddy",
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Moldavite",
    id: 82,
    creator: "Cimota",
    weapon: 15,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Wyvern",
    id: 83,
    creator: "Nxbulah",
    weapon: 15,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Forbidden",
    id: 84,
    creator: "Nxbulah",
    weapon: 15,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Lxd",
    id: 85,
    creator: "Nxbulah",
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Scribble",
    id: 86,
    creator: "FlowerKid",
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peruvia",
    id: 87,
    creator: "Nxbulah",
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Caged",
    id: 88,
    creator: "FlowerKid",
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Lime",
    id: 89,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Berry",
    id: 90,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Indigo",
    id: 91,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Citrus",
    id: 92,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tangerine",
    id: 93,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Grape",
    id: 94,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Canvas",
    id: 95,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Libra",
    id: 96,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Psychedelic",
    id: 97,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Violette",
    id: 98,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Marv",
    id: 99,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Basel",
    id: 100,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Tiger Blood",
    id: 101,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Scalamandre",
    id: 102,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Tiger Maine",
    id: 103,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Leopard",
    id: 104,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Metallic Swirl",
    id: 105,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Tessilate",
    id: 106,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Bubblegum",
    id: 107,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Peppermint",
    id: 108,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Spearmint",
    id: 109,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Obsydian",
    id: 110,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Pink Panther",
    id: 111,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Amber",
    id: 112,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Clover",
    id: 113,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Multicam",
    id: 114,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Aquaric",
    id: 115,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Heather",
    id: 116,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Carbonfibre",
    id: 117,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cobra",
    id: 118,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Python",
    id: 119,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Lost",
    id: 120,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Blue Maze",
    id: 121,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Yellow Maze",
    id: 122,
    weapon: 15,
    rarity: 0,
    seas: 3,
  },
  {
    name: "Morgana",
    id: 123,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Timeless",
    creator: "Chromatikk",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 12,
    type: 3,
    scl: 2.6,
    seas: 3,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 3,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Crimson Tiger",
    creator: "Kltter",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 7,
    type: 3,
    scl: 2.6,
    seas: 3,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 3,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Vaporblade",
    creator: "Jonschmiddy",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 8,
    type: 3,
    scl: 2.6,
    seas: 3,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 3,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Verdant",
    creator: "Jonschmiddy",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 9,
    type: 3,
    scl: 2.6,
    seas: 3,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 3,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Zvilpogghua",
    creator: "Jonschmiddy",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 10,
    frames: 4,
    frameT: 250,
    type: 3,
    scl: 2.6,
    seas: 3,
    glow: true,
    pulsT: 0.0015,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 4,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Volcanic",
    creator: "BigBBaniel",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 11,
    glow: true,
    frames: 4,
    frameT: 250,
    type: 3,
    scl: 2.6,
    seas: 3,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 4,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
  },
  {
    name: "Flintstone",
    creator: "Skriller33",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    pulsT: 0.1,
    id: 2,
    tex: 2,
    type: 3,
    scl: 3,
    seas: 3,
    sclMlt: 0.98,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Raynb0w",
    creator: "???",
    keyW: "Knife",
    pat: 1,
    tex: "weapons/pat/1",
    sameGlow: true,
    movT: 0.0015,
    id: 0,
    type: 3,
    scl: 2.3,
    seas: 3,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 5,
  },
  {
    name: "C0b4lt",
    creator: "???",
    pat: 5,
    tex: "weapons/pat/5",
    sameGlow: true,
    movT: 0.0005,
    seas: 3,
    weapon: 16,
    rarity: 5,
  },
  {
    name: "Shattered Asura",
    id: 53,
    tex: 2,
    rarity: 5,
    glow: true,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    sitOff: -0.65,
    sitOffZ: -0.6,
    seas: 3,
    movT: 0.0003,
  },
  {
    name: "Pellucid",
    creator: "???",
    pat: 8,
    tex: "weapons/pat/8",
    sameGlow: true,
    movT: 0.0003,
    weapon: 1,
    opac: 0.6,
    rarity: 5,
    seas: 3,
  },
  {
    name: "Pellucid",
    creator: "???",
    pat: 8,
    tex: "weapons/pat/8",
    sameGlow: true,
    movT: 0.0003,
    weapon: 2,
    opac: 0.6,
    rarity: 5,
    seas: 3,
  },
  {
    name: "Pellucid",
    creator: "???",
    mid: 0,
    midT: 102,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    sameGlow: true,
    movT: 0.0003,
    weapon: 6,
    opac: 0.6,
    rarity: 5,
    seas: 3,
  },
  {
    name: "Soul Harvest",
    id: 53,
    tex: 3,
    rarity: 5,
    glow: true,
    type: 2,
    opac: 0.6,
    keyW: "Body",
    sclMlt: 2.4,
    sitOff: -0.65,
    sitOffZ: -0.6,
    seas: 3,
    movT: 0.0003,
  },
  {
    name: "Hackusate",
    id: 203,
    weapon: 1,
    rarity: 5,
    rgb: true,
    rgbs: 0.5,
    wire: true,
    seas: 3,
  },
  {
    name: "Kortex",
    id: 204,
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Bloodlust",
    id: 185,
    creator: "FlowerKid",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Hellhound",
    id: 186,
    creator: "Kilfy",
    weapon: 4,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Explora",
    id: 187,
    creator: "Luminae",
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Outrunner",
    creator: "Kltter",
    mid: 0,
    midT: 103,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    glow: true,
    pulsT: 0.0015,
    weapon: 6,
    rarity: 4,
    seas: 3,
  },
  {
    name: "Stanik",
    mid: 0,
    midT: 41,
    creator: "Cimota",
    weapon: 8,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Eaglx",
    mid: 0,
    midT: 42,
    creator: "Kltter",
    weapon: 8,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Aesthetica",
    mid: 0,
    midT: 43,
    creator: "Luminae",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Aries",
    mid: 0,
    midT: 44,
    creator: "Chromatikk",
    weapon: 8,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Puppet Master",
    id: 110,
    rarity: 4,
    noHead: true,
    type: 1,
    keyW: "Hat",
    xOff: 1,
    yOff: -0.5,
    sclMlt: 0.5,
    sitOff: 1.05,
    seas: 3,
    illicit: true,
    funds: 2000,
    reqT: "No Greenskins!",
    req: function () {
      return false;
    },
  },
  {
    name: "Nuke Tamer",
    keyW: "Back",
    id: 56,
    type: 2,
    scl: 3,
    sclMlt: 2.6,
    sitOff: -1.1,
    sitOffZ: -2,
    yOff: -0.9,
    xOff: -0.3,
    rarity: 5,
    seas: 3,
    rAnim: -0.002,
    rAnimA: "x",
    noSale: true,
    illicit: true,
    funds: 3000,
    reqT: "Call in 1000 Nukes",
    req: function (d) {
      return d && d.stats && (d.stats.n || 0) >= 1000;
    },
  },
  {
    name: "Floatie",
    id: 0,
    type: 6,
    keyW: "Waist",
    scl: 2.1,
    spnScl: 2.5,
    sclMlt: 1.8,
    yOff: -1.5,
    xOff: 0.5,
    prevRot: 4,
    rarity: 5,
    seas: 3,
  },
  {
    name: "Combat Banana",
    keyW: "Knife",
    snd: true,
    id: 14,
    type: 3,
    scl: 1.7,
    sclMlt: 0.9,
    yOff: -0.5,
    xOff: -1,
    rarity: 4,
    seas: 3,
  },
  {
    name: "Banana Tail",
    id: 2,
    type: 6,
    keyW: "Waist",
    scl: 2.1,
    spnScl: 2.5,
    sclMlt: 2.5,
    sitOff: 1.9,
    sitOffZ: -3,
    yOff: -1.5,
    xOff: 0.5,
    prevRot: 4,
    rarity: 4,
    seas: 3,
  },
  {
    name: "Cyber Midnight",
    id: 207,
    creator: "SplatterSponge",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Delirium",
    id: 206,
    creator: "floatingpoint",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Mosasaur",
    id: 207,
    creator: "BigBBaniel",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Captane",
    id: 134,
    creator: "Nxbulah",
    weapon: 5,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Tiger Cascade",
    id: 122,
    creator: "Multihawk",
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Flamer",
    mid: 0,
    midT: 45,
    creator: "Multihawk",
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "MOS",
    mid: 0,
    midT: 46,
    creator: "Kltter",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Dynamite",
    mid: 0,
    midT: 43,
    creator: "Destroy007",
    weapon: 10,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Rye",
    id: 124,
    creator: "Nxbulah",
    weapon: 15,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Isotope Mk2",
    id: 125,
    creator: "Multihawk",
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Izulu",
    id: 208,
    creator: "Kilfy",
    weapon: 1,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Izula",
    id: 209,
    creator: "Kilfy",
    weapon: 1,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Milestone",
    id: 208,
    creator: "Kilfy",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Antidote XVI",
    keyW: "Knife",
    rarity: 5,
    seas: 3,
    id: 15,
    type: 3,
    scl: 1.25,
    sclMlt: 0.98,
    yOff: -2,
    alpha: 0.02,
    opac: 1,
    noSale: true,
    illicit: true,
    funds: 10000,
    reqT: "???????",
    req: function (d) {
      return d && d.stats && (d.stats.ggr || 0) >= 59961;
    },
  },
  {
    name: "Tropic Pop",
    id: 209,
    creator: "Exxor",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cyclonic Charge",
    id: 188,
    creator: "Multihawk",
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Disco Kill",
    id: 189,
    creator: "Destroy007",
    weapon: 4,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Line Breaker",
    id: 135,
    creator: "Multihawk",
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Rev 2058",
    id: 136,
    creator: "Destroy007",
    weapon: 5,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Sarin",
    mid: 0,
    midT: 104,
    creator: "Floatingpoint",
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Nitrox",
    mid: 0,
    midT: 105,
    creator: "Destroy007",
    weapon: 6,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Fireball",
    mid: 0,
    midT: 47,
    creator: "Destroy007",
    weapon: 8,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Noble Guard",
    mid: 0,
    midT: 48,
    creator: "Multihawk",
    weapon: 8,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Institute",
    mid: 0,
    midT: 49,
    creator: "Floatingpoint",
    weapon: 8,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Charoite",
    mid: 0,
    midT: 44,
    creator: "Cimota",
    weapon: 10,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Stream Suit",
    limT: "Twitch #1",
    id: 10,
    shirtCol: 6570405,
    sleeveCol: 16448250,
    pantsCol: 6570405,
    shoeCol: 16448250,
    seas: 3,
    type: 5,
    noSpin: true,
    rarity: 4,
  },
  {
    name: "USS Krunk",
    keyW: "Waist",
    rarity: 5,
    seas: 3,
    id: 4,
    type: 6,
    scl: 2.1,
    spnScl: 2.5,
    sclMlt: 2.8,
    yOff: -1.5,
    xOff: -1,
    sitOff: 1,
    glow: true,
    prevRot: 4,
    side: 2,
    alpha: 0.7,
    trans: true,
    frames: 2,
    frameT: 300,
    noLegs: true,
    noSale: true,
    illicit: true,
    funds: 10000,
    reqT: "Level 50 Runner",
    req: function (d) {
      return d && d.stats && (d.stats.c9 || 0) >= 2667778;
    },
  },
  {
    name: "USS TTV",
    keyW: "Waist",
    limT: "Twitch #1",
    tex: 1,
    rarity: 5,
    seas: 3,
    id: 4,
    type: 6,
    scl: 2.1,
    spnScl: 2.5,
    sclMlt: 2.8,
    yOff: -1.5,
    xOff: -1,
    sitOff: 1,
    prevRot: 4,
    glow: true,
    side: 2,
    alpha: 0.7,
    trans: true,
    frames: 2,
    frameT: 300,
    noLegs: true,
    noSpin: true,
  },
  {
    name: "TTV",
    keyW: "Sprays",
    limT: "Twitch #1",
    id: 80,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.8,
    noSpin: true,
  },
  {
    name: "TTV Cape",
    limT: "Twitch #1",
    id: 52,
    tex: 3,
    rarity: 4,
    side: 2,
    glow: true,
    type: 2,
    keyW: "Body",
    xRot: 3,
    xOff: -1,
    yOff: 0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -0.5,
    sitOffZ: -0.6,
    seas: 3,
    noSpin: true,
  },
  {
    name: "TTV Tron",
    limT: "Twitch #1",
    id: 32,
    tex: 6,
    rarity: 3,
    type: 1,
    keyW: "Head",
    seas: 3,
    scl: 1,
    glow: true,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    frames: 2,
    frameT: 400,
    noSpin: true,
  },
  {
    name: "Krunk TTV",
    limT: "Twitch #1",
    id: 32,
    tex: 7,
    rarity: 3,
    type: 1,
    keyW: "Head",
    seas: 3,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 2.05,
    yOff: -3.2,
    frames: 4,
    frameT: 400,
    noSpin: true,
  },
  {
    name: "Twitched",
    limT: "Twitch #1",
    id: 111,
    rarity: 2,
    type: 1,
    keyW: "Head",
    seas: 3,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 0.75,
    yOff: -1,
    noSpin: true,
    noHead: true,
  },
  {
    name: "tRaDeS?",
    keyW: "Sprays",
    limT: "Twitch #1",
    id: 81,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.8,
    noSpin: true,
  },
  {
    name: "Partner Push",
    keyW: "Sprays",
    limT: "Twitch #1",
    id: 82,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.8,
    noSpin: true,
  },
  {
    name: "Mic'd Up",
    keyW: "Knife",
    limT: "Twitch #1",
    noSpin: true,
    rarity: 4,
    seas: 3,
    id: 17,
    type: 3,
    scl: 1,
    sclMlt: 0.8,
    yOff: -2,
    frames: 2,
    frameT: 500,
    sxOff: 0.5,
    syOff: -0.05,
    szOff: -0.1,
  },
  {
    name: "Zed",
    keyW: "Sprays",
    limT: "Twitch #1",
    id: 84,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.8,
    noSpin: true,
  },
  {
    name: "Kaarson",
    keyW: "Sprays",
    limT: "Twitch #1",
    id: 86,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.8,
    noSpin: true,
  },
  {
    name: "TTV Vest",
    limT: "Twitch #1",
    noSpin: true,
    id: 58,
    rarity: 2,
    type: 2,
    keyW: "Back",
    seas: 3,
    scl: 0.5,
    sclMlt: 0.5,
    sitOff: 1.7,
    sitOffZ: 0,
    yOff: -2,
    xRot: Math.PI,
  },
  {
    name: "Cheerfull",
    limT: "Twitch #1",
    noSpin: true,
    id: 57,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Back",
    xOff: -2.5,
    yOff: -2,
    xRot: -0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -1.65,
    sitOffZ: -0.7,
    seas: 3,
  },
  {
    name: "Twitcher",
    limT: "Twitch #1",
    noSpin: true,
    id: 210,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Streamer",
    limT: "Twitch #1",
    noSpin: true,
    mid: 0,
    midT: 50,
    creator: "Chromatikk",
    weapon: 8,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "TTV-Cap",
    limT: "Twitch #1",
    noSpin: true,
    tex: 2,
    id: 74,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    yOff: -1.5,
    xOff: 1,
    sclMlt: 0.5,
    sitOff: 0.8,
    seas: 3,
  },
  {
    name: "Bits",
    limT: "Twitch #1",
    noSpin: true,
    id: 112,
    rarity: 5,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: -1.5,
    rAnim: -0.0016,
    rAnimA: "y",
    seas: 3,
  },
  {
    name: "Just Vibing",
    limT: "Twitch #1",
    creator: "???",
    pat: 11,
    tex: "weapons/pat/11",
    sameGlow: true,
    movT: 0.0003,
    movD: 1,
    tileS: 3,
    weapon: 1,
    rarity: 4,
    seas: 3,
    noSpin: true,
  },
  {
    name: "Arae Atlas",
    id: 210,
    creator: "Luminae",
    weapon: 1,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Rezein",
    id: 211,
    creator: "Nxbulah",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "ThiccChemist",
    id: 212,
    creator: "Nxbulah",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Radalive",
    id: 213,
    creator: "Kilfy",
    weapon: 1,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Arctic",
    id: 211,
    creator: "Destroy007",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Kanashii",
    id: 190,
    creator: "Whippii",
    weapon: 4,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Sunset claw",
    id: 137,
    creator: "Kilfy",
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Blazed",
    id: 123,
    creator: "Cimota",
    weapon: 7,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Avalan",
    mid: 0,
    midT: 51,
    creator: "Nxbulah",
    weapon: 8,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Disruptor",
    mid: 0,
    midT: 52,
    creator: "Multihawk",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Phusion",
    mid: 0,
    midT: 53,
    creator: "Nxbulah",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Midnight Phoenix",
    id: 126,
    creator: "Destroy007",
    weapon: 15,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Ocean",
    mid: 0,
    midT: 45,
    creator: "Skriller33",
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Thunder God",
    mid: 0,
    midT: 42,
    creator: "Chromatikk",
    weapon: 10,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Upset",
    id: 214,
    creator: "Kilfy",
    weapon: 1,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Fished",
    id: 212,
    creator: "Skriller33",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Hannya",
    id: 213,
    creator: "Whippii",
    weapon: 2,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Drakon",
    id: 214,
    creator: "Kltter",
    weapon: 2,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "caL",
    id: 215,
    creator: "Kilfy",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "CIRO",
    id: 191,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Redolent",
    id: 138,
    creator: "Cimota",
    weapon: 5,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Man vs God",
    mid: 0,
    midT: 54,
    creator: "Chromatikk",
    weapon: 8,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Scaze",
    id: 127,
    creator: "Kilfy",
    weapon: 15,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Kinto",
    creator: "Nxbulah",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    pulsT: 0.1,
    tex: 4,
    id: 2,
    type: 3,
    scl: 3,
    seas: 3,
    sclMlt: 0.98,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Divine",
    creator: "Destroy007",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    pulsT: 0.1,
    tex: 5,
    id: 2,
    type: 3,
    scl: 3,
    seas: 3,
    sclMlt: 0.98,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Diabolo",
    creator: "Destroy007",
    keyW: "Knife",
    animInd: 1,
    glow: true,
    tex: 6,
    id: 2,
    type: 3,
    scl: 3,
    seas: 3,
    sclMlt: 0.98,
    yOff: -2,
    rarity: 4,
  },
  {
    name: "Fadecrusher",
    creator: "Multihawk",
    keyW: "Knife",
    glow: true,
    pulsT: 0.0015,
    id: 4,
    tex: 2,
    type: 3,
    seas: 3,
    rarity: 5,
    scl: 2,
    sclMlt: 0.75,
    yOff: -1,
    sxOff: 0,
    syOff: -0.05,
    szOff: -0.1,
  },
  {
    name: "Crimson Edge",
    creator: "Multihawk",
    id: 9,
    tex: 1,
    rarity: 4,
    type: 3,
    sxOff: 0.4,
    scl: 1.4,
    yOff: -2,
    keyW: "Melee",
    seas: 3,
  },
  {
    name: "Alter",
    creator: "_irizu",
    glow: true,
    pulsT: 0.0015,
    id: 10,
    tex: 1,
    rarity: 5,
    type: 3,
    sxRot: -0.3,
    syOff: 0.1,
    szOff: -0.1,
    scl: 0.8,
    yOff: -1,
    xOff: -1,
    keyW: "Melee",
    seas: 3,
  },
  {
    name: "Prototype-14",
    id: 0,
    creator: "Multihawk",
    weapon: 14,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Dream Destroyer",
    id: 1,
    creator: "Destroy007",
    weapon: 14,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "E-12",
    id: 2,
    creator: "Cimota",
    weapon: 14,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "T.A.N 9",
    id: 3,
    creator: "Floatingpoint",
    weapon: 14,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Sekigahara",
    id: 215,
    creator: "Flower Kid",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Death Parade",
    id: 216,
    creator: "Flower Kid",
    weapon: 1,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Sentinel-56",
    id: 217,
    creator: "Cimota",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Cryptic J",
    id: 216,
    creator: "Nxbulah & Kilfy",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Voyage",
    id: 192,
    creator: "Cimota",
    weapon: 4,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Iara",
    id: 193,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Insidious",
    mid: 0,
    midT: 106,
    creator: "Cimota",
    weapon: 6,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Tri-Tech",
    id: 124,
    creator: "Multihawk",
    weapon: 7,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Prototype BWSX",
    id: 0,
    creator: "Floatingpoint",
    weapon: 11,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Hexgen",
    id: 1,
    creator: "Nxbulah",
    weapon: 11,
    rarity: 5,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Scout Mastery",
    mid: 5,
    seas: 3,
    weapon: 1,
    rarity: 5,
    noSale: true,
    illicit: true,
    funds: 10000,
    yOrg: -0.2,
    reqT: "Level 100 Hunter",
    req: function (d) {
      return d && d.stats && (d.stats.c1 || 0) >= 10890000;
    },
  },
  {
    name: "Redux",
    id: 10,
    tex: 2,
    rarity: 5,
    type: 3,
    sxRot: -0.3,
    syOff: 0.1,
    szOff: -0.1,
    scl: 0.8,
    yOff: -1,
    xOff: -1,
    keyW: "Melee",
    seas: 3,
    shaderId: 0,
  },
  {
    name: "Neon Dance",
    id: 52,
    tex: 4,
    rarity: 5,
    side: 2,
    glow: true,
    type: 2,
    keyW: "Body",
    xRot: 3,
    xOff: -1,
    yOff: 0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -0.5,
    sitOffZ: -0.6,
    seas: 3,
    shaderId: 1,
  },
  {
    name: "Jason",
    limT: "Twitch #2",
    id: 113,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.5,
    sitOff: 1,
    yOff: -0.7,
    xOff: 1,
    trans: true,
  },
  {
    name: "Sicko",
    limT: "Twitch #2",
    id: 114,
    glow: true,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.5,
    sitOff: 1,
    yOff: -0.7,
    xOff: 1,
    trans: true,
  },
  {
    name: "Succubus",
    limT: "Twitch #2",
    id: 115,
    glow: true,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.45,
    sitOff: 0.4,
    yOff: -0.7,
    xOff: 0.2,
  },
  {
    name: "Socket",
    limT: "Twitch #2",
    noHead: true,
    id: 116,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 0.2,
  },
  {
    name: "Crunch",
    limT: "Twitch #2",
    noHead: true,
    id: 117,
    rarity: 1,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 0.2,
  },
  {
    name: "Paraseye",
    limT: "Twitch #2",
    noHead: true,
    id: 118,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.7,
    sitOff: 0.9,
    yOff: -0.7,
  },
  {
    name: "Puff Puff",
    limT: "Twitch #2",
    noHead: true,
    id: 119,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.8,
    sitOff: 0.8,
    yOff: -0.7,
  },
  {
    name: "Moneybags",
    limT: "Twitch #2",
    noHead: true,
    id: 121,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
  },
  {
    name: "Braindead",
    limT: "Twitch #2",
    noHead: true,
    id: 122,
    rarity: 2,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.8,
    sitOff: 1,
    yOff: -0.7,
    trans: true,
  },
  {
    name: "Gobbler",
    limT: "Twitch #2",
    noHead: true,
    id: 123,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.8,
    sitOff: 1,
    yOff: -0.7,
  },
  {
    name: "Seefood",
    limT: "Twitch #2",
    noHead: true,
    id: 124,
    glow: true,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.7,
    sitOff: 0.9,
    yOff: -0.7,
    trans: true,
  },
  {
    name: "Mr Doodles",
    limT: "Twitch #2",
    noHead: true,
    id: 125,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    trans: true,
  },
  {
    name: "Drowned",
    limT: "Twitch #2",
    id: 126,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
    trans: true,
  },
  {
    name: "Tentacle",
    limT: "Twitch #2",
    id: 59,
    rarity: 4,
    type: 2,
    keyW: "Body",
    seas: 3,
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: -1,
    sitOff: -0.7,
    sitOffZ: -0.65,
  },
  {
    name: "Observer",
    limT: "Twitch #2",
    id: 60,
    rarity: 5,
    type: 2,
    keyW: "Body",
    seas: 3,
    scl: 3,
    sclMlt: 2.6,
    sitOff: -1.1,
    sitOffZ: -2,
    yOff: -0.9,
    xOff: -0.3,
    rAnim: -0.002,
    rAnimA: "x",
  },
  {
    name: "Butcher",
    limT: "Twitch #2",
    id: 61,
    rarity: 2,
    type: 2,
    keyW: "Body",
    seas: 3,
    scl: 4.5,
    spnScl: 3.5,
    sclMlt: 2.55,
    sitOff: -0.4,
    yOff: -2,
    prevRot: -0.1,
  },
  {
    name: "Scales",
    limT: "Twitch #2",
    id: 62,
    rarity: 2,
    type: 2,
    keyW: "Body",
    seas: 3,
    scl: 4.5,
    spnScl: 3.5,
    sclMlt: 2.55,
    sitOff: -0.4,
    yOff: -1,
    xOff: -1,
    xRot: Math.PI,
  },
  {
    name: "Pauldrons",
    limT: "Twitch #2",
    id: 64,
    rarity: 2,
    type: 2,
    keyW: "Body",
    seas: 3,
    scl: 4.5,
    sclMlt: 2.3,
    sitOff: -0.6,
    yOff: -2,
    xRot: Math.PI,
  },
  {
    name: "Walpurgis",
    limT: "Twitch #2",
    id: 5,
    rarity: 4,
    type: 6,
    keyW: "Waist",
    seas: 3,
    scl: 2.1,
    spnScl: 3,
    sclMlt: 2.6,
    sitOff: 1.4,
    prevRot: 4,
    xOff: -2,
    noLegs: true,
  },
  {
    name: "Scales",
    limT: "Twitch #2",
    id: 7,
    rarity: 3,
    type: 6,
    keyW: "Waist",
    seas: 3,
    scl: 2.1,
    spnScl: 3,
    sitOff: 1,
    sitOffZ: 1,
    sclMlt: 2.6,
    prevRot: 2,
    xOff: -3.5,
    xRot: Math.PI * 0.6,
  },
  {
    name: "Monster V",
    limT: "Twitch #2",
    id: 89,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.9,
    keyW: "Sprays",
  },
  {
    name: "Monster III",
    limT: "Twitch #2",
    id: 91,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.9,
    keyW: "Sprays",
  },
  {
    name: "Monster X",
    limT: "Twitch #2",
    id: 92,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.9,
    keyW: "Sprays",
  },
  {
    name: "Demonic Haze",
    limT: "Twitch #2",
    id: 218,
    creator: "Kilfy",
    weapon: 1,
    rarity: 5,
    glow: true,
    seas: 3,
  },
  {
    name: "Vassago",
    limT: "Twitch #2",
    id: 219,
    creator: "Lxckless",
    weapon: 1,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    id: 220,
    weapon: 1,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    id: 221,
    weapon: 1,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Poseidon",
    limT: "Twitch #2",
    id: 217,
    creator: "Atomize",
    weapon: 2,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Overseer",
    limT: "Twitch #2",
    id: 218,
    creator: "Luminae",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Etona",
    limT: "Twitch #2",
    id: 219,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "NeoTitan",
    limT: "Twitch #2",
    id: 220,
    creator: "FlowerKid",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Full Moon",
    limT: "Twitch #2",
    id: 221,
    creator: "Kristai",
    weapon: 2,
    rarity: 4,
    frames: 4,
    frameT: 250,
    seas: 3,
  },
  {
    name: "Nightmare",
    limT: "Twitch #2",
    id: 222,
    creator: "CreshorTV",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Crimson",
    limT: "Twitch #2",
    id: 223,
    creator: "Chromatikk",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Corruption",
    limT: "Twitch #2",
    id: 224,
    creator: "Chromatikk",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Overwatch",
    limT: "Twitch #2",
    id: 194,
    creator: "Destroy007",
    weapon: 4,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    id: 195,
    weapon: 4,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    id: 196,
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Symbiote",
    limT: "Twitch #2",
    id: 139,
    creator: "Whippii",
    weapon: 5,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    id: 140,
    weapon: 5,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    id: 141,
    weapon: 5,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    mid: 0,
    midT: 107,
    weapon: 6,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    mid: 0,
    midT: 108,
    weapon: 6,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Toxic Rider",
    limT: "Twitch #2",
    id: 125,
    creator: "Destroy007",
    weapon: 7,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Knightingale",
    limT: "Twitch #2",
    id: 126,
    creator: "FailBucket",
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    id: 127,
    weapon: 7,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    id: 128,
    weapon: 7,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Wildlife",
    limT: "Twitch #2",
    mid: 0,
    midT: 55,
    creator: "Destroy007",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    mid: 0,
    midT: 56,
    weapon: 8,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    mid: 0,
    midT: 57,
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    mid: 0,
    midT: 46,
    weapon: 10,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    mid: 0,
    midT: 47,
    weapon: 10,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Devourer",
    limT: "Twitch #2",
    id: 2,
    creator: "Kilfy",
    weapon: 11,
    rarity: 5,
    glow: true,
    seas: 3,
  },
  {
    name: "Ignis",
    limT: "Twitch #2",
    id: 128,
    weapon: 15,
    rarity: 1,
    seas: 3,
  },
  {
    name: "Cranium",
    limT: "Twitch #2",
    id: 129,
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Arachnidis",
    limT: "Twitch #2",
    id: 46,
    tex: 1,
    rarity: 5,
    type: 2,
    keyW: "Body",
    sclMlt: 2.4,
    spnScl: 2.6,
    xOff: 1,
    xRot: 2.5,
    sitOff: -0.9,
    sitOffZ: -0.6,
    seas: 3,
    shaderId: 3,
  },
  {
    name: "Infinity Cloak",
    limT: "Twitch #2",
    id: 52,
    tex: 5,
    rarity: 5,
    side: 2,
    type: 2,
    keyW: "Body",
    xRot: 2,
    xOff: -1,
    yOff: 0.5,
    spnScl: 2.6,
    sclMlt: 2.4,
    sitOff: -0.5,
    sitOffZ: -0.6,
    seas: 3,
    shaderId: 3,
  },
  {
    name: "Sorable",
    keyW: "Sprays",
    limT: "Twitch #2",
    id: 93,
    type: 4,
    rarity: 1,
    seas: 3,
    opacity: 0.8,
  },
  {
    name: "Stremz",
    keyW: "Sprays",
    limT: "Twitch #2",
    id: 94,
    type: 4,
    rarity: 2,
    seas: 3,
    opacity: 0.8,
  },
  {
    name: "Void Slicer",
    keyW: "Knife",
    flipAnim: true,
    id: 3,
    tex: 13,
    type: 3,
    scl: 2.6,
    seas: 3,
    sclMlt: 1,
    yOff: -1,
    xOff: -1.5,
    rarity: 5,
    sxRot: 0.3,
    sxOff: 0.35,
    szOff: -0.25,
    shaderId: 3,
  },
  {
    name: "Steel Serpent",
    id: 222,
    creator: "Chromatikk",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Theta Republica",
    id: 223,
    creator: "Floatingpoint",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Cactus Jack",
    id: 225,
    creator: "Kltter",
    weapon: 2,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Jakku",
    id: 197,
    creator: "Kltter",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Shortcake",
    id: 130,
    creator: "Kristai",
    weapon: 15,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Resurrection",
    id: 224,
    creator: "Kilfy",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Bopper",
    id: 225,
    creator: "FlowerKid",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Containment",
    id: 226,
    creator: "Atomize",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Sunshine",
    id: 227,
    creator: "CreshorTV",
    weapon: 1,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Tedssyt",
    limT: "Twitch #2",
    id: 228,
    creator: "Cimota",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Onamu",
    id: 226,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Pestilence",
    limT: "Twitch #2",
    id: 227,
    creator: "Chromatikk",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Signal",
    limT: "Twitch #2",
    id: 198,
    creator: "FlowerKid",
    weapon: 4,
    rarity: 3,
    frames: 4,
    frameT: 250,
    glow: true,
    seas: 3,
  },
  {
    name: "Graffitius",
    id: 199,
    creator: "Luminae",
    weapon: 4,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Headhunter Alpha",
    id: 200,
    creator: "Multihawk",
    weapon: 4,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Tau",
    id: 201,
    creator: "Floatingpoint",
    weapon: 4,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Kotal",
    id: 142,
    creator: "Nxbulah",
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Imperial",
    mid: 0,
    midT: 109,
    creator: "Cimota",
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Foria",
    mid: 0,
    midT: 110,
    creator: "Nxbulah",
    weapon: 6,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Watercolours",
    mid: 0,
    midT: 58,
    creator: "Multihawk",
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Luminescence",
    mid: 0,
    midT: 48,
    creator: "FailBucket",
    weapon: 10,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "SunBurst Swirl",
    mid: 0,
    midT: 49,
    creator: "Exxor",
    weapon: 10,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Sanctum",
    id: 3,
    creator: "Multihawk",
    weapon: 11,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Futurai",
    id: 4,
    creator: "Destroy007",
    weapon: 14,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Fish Warfare",
    id: 5,
    creator: "Multihawk",
    weapon: 14,
    rarity: 2,
    glow: true,
    seas: 3,
  },
  {
    name: "Hunter",
    id: 6,
    creator: "Multihawk",
    weapon: 14,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Kortal",
    id: 131,
    creator: "Destroy007",
    weapon: 15,
    rarity: 3,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Modular",
    id: 0,
    creator: "Floatingpoint",
    weapon: 17,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Googly",
    limT: "Twitch #2",
    id: 127,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.5,
    sitOff: 1,
    yOff: -0.7,
    xOff: 1,
    trans: true,
  },
  {
    name: "Despair",
    creator: "Kilfy",
    keyW: "Knife",
    tex: 7,
    id: 2,
    glow: true,
    type: 3,
    seas: 3,
    scl: 3,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 5,
  },
  {
    name: "Death Rattle",
    id: 228,
    creator: "CreshorTV",
    weapon: 2,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Cinder",
    id: 202,
    creator: "Kilfy",
    weapon: 4,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Overloaded",
    id: 1,
    creator: "Kilfy",
    weapon: 12,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Happy",
    id: 0,
    rarity: 3,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Smooch",
    id: 0,
    tex: 1,
    rarity: 4,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Kawaii",
    id: 0,
    tex: 2,
    rarity: 3,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Smirk",
    id: 0,
    tex: 3,
    rarity: 3,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Upset",
    id: 0,
    tex: 4,
    rarity: 4,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Ravatron",
    id: 130,
    rarity: 5,
    type: 1,
    glow: true,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
    trans: true,
  },
  {
    name: "Demon Baby",
    noHead: true,
    id: 131,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.8,
    sitOff: 0.8,
    yOff: -0.7,
  },
  {
    name: "Soulless",
    noHead: true,
    id: 132,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.8,
    sitOff: 0.8,
    yOff: -0.7,
  },
  {
    name: "Krunkuto",
    id: 133,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.5,
    sitOff: 1,
    yOff: -0.7,
    xOff: 1,
    trans: true,
  },
  {
    name: "5Head",
    noHead: true,
    id: 134,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
  },
  {
    name: "Deadball",
    noHead: true,
    id: 135,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.8,
    sitOff: 0.8,
    yOff: -0.7,
  },
  {
    name: "UwU",
    id: 0,
    tex: 5,
    rarity: 3,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Pierre",
    id: 0,
    tex: 6,
    rarity: 3,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Voodoo",
    id: 0,
    tex: 7,
    rarity: 4,
    type: 7,
    keyW: "Face",
    seas: 3,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
  },
  {
    name: "Heart Cycle",
    id: 229,
    creator: "Whippii",
    weapon: 1,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Whippii",
    id: 230,
    creator: "Whippii",
    weapon: 1,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Automaton",
    id: 231,
    creator: "Kilfy",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Soda-Licious",
    id: 229,
    creator: "Whippii",
    weapon: 2,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "TnT",
    midT: 3,
    noMuz: true,
    mid: 0,
    weapon: 3,
    spnScl: 1.3,
    scl: 0.9,
    mScl: 0.84,
    zOff: 0,
    yOff: 0,
    rarity: 3,
    creator: "Destroy007",
    seas: 3,
  },
  {
    name: "Acid Bark",
    id: 143,
    creator: "CreshorTV",
    weapon: 5,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Wharf",
    mid: 0,
    midT: 59,
    creator: "Whippii",
    weapon: 8,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Railix V",
    id: 4,
    creator: "Kilfy",
    weapon: 11,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Sidious",
    id: 5,
    creator: "Nxbulah",
    weapon: 11,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Fleece",
    id: 6,
    creator: "Whippii",
    weapon: 11,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Proton XV",
    id: 2,
    creator: "Cimota",
    weapon: 12,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "VR-4",
    id: 132,
    creator: "Floatingpoint",
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Pip Squeak",
    id: 2,
    creator: "Cimota",
    weapon: 16,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Turbocharged",
    id: 1,
    creator: "ReDeagle",
    weapon: 16,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Spock",
    noHead: true,
    id: 136,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
  },
  {
    name: "Miss Package",
    noHead: true,
    id: 137,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
  },
  {
    name: "Lil Jack",
    noHead: true,
    id: 138,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
  },
  {
    name: "Disco Mouse",
    id: 139,
    rarity: 5,
    type: 1,
    glow: true,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
    trans: true,
  },
  {
    name: "Innocent",
    noHead: true,
    id: 141,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
  },
  {
    name: "Bot 2",
    id: 101,
    tex: 1,
    rarity: 4,
    glow: true,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 0.9,
    seas: 3,
  },
  {
    name: "Balloon",
    noHead: true,
    id: 140,
    rarity: 4,
    type: 1,
    keyW: "Hat",
    seas: 3,
    scl: 1,
    sclMlt: 0.8,
    sitOff: 0.25,
    yOff: -0.7,
  },
  {
    name: "Disco Shirt",
    id: 67,
    rarity: 4,
    glow: true,
    type: 2,
    keyW: "Body",
    seas: 3,
    scl: 1,
    sclMlt: 0.48,
    sitOff: -0.6,
    yOff: -1,
    xOff: -1,
    trans: true,
  },
  {
    name: "Shuriken",
    keyW: "Knife",
    flipAnim: true,
    snd: true,
    id: 19,
    glow: true,
    type: 3,
    seas: 3,
    scl: 1.5,
    sclMlt: 0.9,
    yOff: -2,
    rarity: 5,
    sxRot: 0.3,
    sxOff: 0.15,
    szOff: -0.35,
    syOff: 0.1,
    noSale: true,
    illicit: true,
    funds: 10000,
    reqT: "10000 Thrown Melee Kills",
    req: function (d) {
      return d && d.stats && (d.stats.tmk || 0) >= 10000;
    },
  },
  {
    name: "Mamba",
    keyW: "Knife",
    id: 20,
    type: 3,
    seas: 3,
    scl: 1,
    sclMlt: 0.7,
    yOff: -2,
    rarity: 4,
    sxRot: 0.3,
    sxOff: 0.05,
    szOff: -0.55,
    syOff: 0.6,
  },
  {
    name: "Arcturus",
    limT: "Charity",
    noSale: true,
    noSpin: true,
    id: 232,
    creator: "Nxbulah",
    weapon: 1,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Celeste",
    limT: "Charity",
    noSale: true,
    noSpin: true,
    id: 230,
    creator: "Nxbulah",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Warlock",
    limT: "Charity",
    noSale: true,
    noSpin: true,
    rarity: 3,
    seas: 3,
    id: 142,
    type: 1,
    sclMlt: 0.5,
    sitOff: 1,
    yOff: -2,
    keyW: "Hat",
  },
  {
    name: "Starlight",
    limT: "Charity",
    noSpin: true,
    noSale: true,
    rarity: 4,
    seas: 3,
    id: 68,
    type: 2,
    scl: 1,
    sclMlt: 0.85,
    sitOff: 0,
    sitOffZ: -0.4,
    yOff: -1,
    xOff: -1,
    keyW: "Body",
  },
  {
    name: "Magic Wand",
    limT: "Charity",
    noSpin: true,
    noSale: true,
    rarity: 3,
    seas: 3,
    id: 21,
    type: 3,
    sxRot: -0.1,
    sxOff: 0.3,
    szOff: -0.1,
    scl: 1.3,
    yOff: -1.5,
    xOff: -1,
    keyW: "Melee",
  },
  {
    name: "Star Power",
    limT: "Charity",
    noSpin: true,
    noSale: true,
    rarity: 2,
    seas: 3,
    id: 95,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
  },
  {
    name: "Shine Bright",
    limT: "Charity",
    noSpin: true,
    noSale: true,
    rarity: 2,
    seas: 3,
    id: 96,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
  },
  {
    name: "Flow",
    id: 231,
    creator: "Luminae",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Freshmint",
    id: 232,
    creator: "Destroy007",
    weapon: 2,
    rarity: 4,
    glow: true,
    pulsT: 0.0015,
    seas: 3,
  },
  {
    name: "Lykos",
    id: 233,
    creator: "Skriller33",
    weapon: 2,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Ragnarok",
    id: 203,
    creator: "Failbucket",
    weapon: 4,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Brainstorm",
    id: 204,
    creator: "Atomize",
    weapon: 4,
    rarity: 2,
    seas: 3,
  },
  {
    name: "FSS Archdaemon",
    id: 129,
    creator: "floatingpoint",
    weapon: 7,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "ZE-14",
    mid: 0,
    midT: 60,
    creator: "Zinoob",
    weapon: 8,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Sly",
    mid: 0,
    midT: 61,
    creator: "Whippii",
    weapon: 8,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Abyssal",
    id: 8,
    creator: "Kilfy",
    weapon: 11,
    rarity: 5,
    glow: true,
    seas: 3,
  },
  {
    name: "Admiral",
    id: 133,
    creator: "_irizu",
    weapon: 15,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Nebulous",
    id: 135,
    creator: "Failbucket",
    weapon: 15,
    rarity: 2,
    seas: 3,
  },
  {
    name: "Azeal",
    id: 136,
    creator: "Kilfy",
    weapon: 15,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "Slayer",
    id: 3,
    creator: "Multihawk",
    weapon: 16,
    rarity: 3,
    seas: 3,
  },
  {
    name: "Skullwood",
    id: 1,
    creator: "Multihawk",
    weapon: 17,
    rarity: 3,
    glow: true,
    seas: 3,
  },
  {
    name: "Big Mouth",
    id: 2,
    creator: "Cimota",
    weapon: 17,
    rarity: 4,
    glow: true,
    seas: 3,
  },
  {
    name: "K.P.D Hat",
    keyW: "Hat",
    id: 143,
    rarity: 4,
    type: 1,
    seas: 3,
    sclMlt: 0.5,
    sitOff: 0.6,
    scl: 1.6,
  },
  {
    name: "K.P.D Uniform",
    id: 11,
    shirtCol: 2369592,
    sleeveCol: 2368548,
    pantsCol: 2369592,
    shoeCol: 2368548,
    seas: 3,
    type: 5,
    rarity: 5,
  },
  {
    name: "AP Rally",
    keyW: "Waist",
    limT: "Clan Wars",
    region: "Asia",
    rarity: 5,
    seas: 3,
    id: 10,
    type: 6,
    scl: 2.1,
    spnScl: 2.5,
    sclMlt: 2.8,
    yOff: -1.5,
    xOff: -1,
    sitOff: 0,
    prevRot: 4,
    glow: true,
    noLegs: true,
    noSpin: true,
    lowR: true,
    noSale: true,
  },
  {
    name: "Chaffee",
    keyW: "Waist",
    limT: "Clan Wars",
    region: "North America",
    rarity: 5,
    seas: 3,
    id: 9,
    type: 6,
    scl: 2.1,
    spnScl: 2.5,
    sclMlt: 2.8,
    yOff: -1.5,
    xOff: -1,
    sitOff: 0,
    prevRot: 4,
    noLegs: true,
    noSpin: true,
    lowR: true,
    noSale: true,
  },
  {
    name: "Magic Carpet",
    keyW: "Waist",
    limT: "Clan Wars",
    region: "Middle East",
    rarity: 5,
    seas: 3,
    id: 8,
    type: 6,
    scl: 2.1,
    spnScl: 3,
    sclMlt: 2.6,
    sitOff: 1.4,
    prevRot: 4,
    xOff: -2,
    noLegs: true,
    noSpin: true,
    lowR: true,
    noSale: true,
  },
  {
    name: "Matryoshka",
    limT: "Clan Wars",
    region: "Eastern Europe",
    noSpin: true,
    id: 129,
    rarity: 5,
    type: 1,
    keyW: "Hat",
    sclMlt: 0.5,
    sitOff: 1,
    rAnim: -0.0016,
    rAnimA: "y",
    seas: 3,
    noSale: true,
  },
  {
    name: "Baluba",
    limT: "Clan Wars",
    region: "Africa",
    noSpin: true,
    id: 128,
    rarity: 5,
    type: 1,
    keyW: "Hat",
    scl: 1,
    sclMlt: 0.48,
    sitOff: 1,
    yOff: -0.7,
    xOff: 3.7,
    seas: 3,
    noSale: true,
  },
  {
    name: "Kali",
    limT: "Clan Wars",
    region: "Oceania",
    keyW: "Back",
    noSpin: true,
    id: 65,
    type: 2,
    scl: 3,
    sclMlt: 2.6,
    sitOff: -1.1,
    sitOffZ: -2,
    yOff: -0.9,
    xOff: -0.3,
    rarity: 5,
    seas: 3,
    rAnim: -0.002,
    rAnimA: "x",
    noSale: true,
  },
  {
    name: "Union",
    limT: "Clan Wars",
    region: "Western Europe",
    keyW: "Back",
    noSpin: true,
    id: 66,
    glow: true,
    type: 2,
    scl: 3,
    sclMlt: 2.6,
    sitOff: -1.1,
    sitOffZ: -2,
    yOff: -0.9,
    xOff: -0.3,
    rarity: 5,
    seas: 3,
    rAnim: -0.002,
    rAnimA: "x",
    noSale: true,
  },
  {
    name: "Macuahuitl",
    limT: "Clan Wars",
    region: "South America",
    noSpin: true,
    id: 18,
    rarity: 4,
    type: 3,
    sxRot: -0.1,
    syOff: 0,
    sxOff: 0.5,
    szOff: -0.2,
    scl: 0.8,
    yOff: -1,
    xOff: -1,
    keyW: "Melee",
    seas: 3,
    glow: true,
    noSale: true,
  },
  {
    name: "Haunter",
    limT: "Raid",
    noSpin: true,
    noSale: true,
    noQuickSell: true,
    rarity: 2,
    seas: 4,
    id: 97,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
  },
  {
    name: "Boo!",
    limT: "Raid",
    noSpin: true,
    noSale: true,
    noQuickSell: true,
    rarity: 2,
    seas: 4,
    id: 98,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
  },
  {
    name: "Ghast",
    keyW: "Waist",
    limT: "Raid",
    rarity: 4,
    seas: 4,
    id: 11,
    type: 6,
    glow: true,
    opac: 0.9,
    scl: 2.1,
    spnScl: 3,
    color: 3823936,
    sclMlt: 0.45,
    sitOff: 0.4,
    prevRot: 4,
    xOff: -2,
    noLegs: true,
    noSpin: true,
    noQuickSell: true,
    lowR: true,
    noSale: true,
  },
  {
    name: "Pumpking",
    keyW: "Hat",
    limT: "Raid",
    id: 144,
    rarity: 4,
    type: 1,
    glow: true,
    seas: 4,
    scl: 1,
    sclMlt: 0.6,
    sitOff: 0.85,
    yOff: -0.7,
    xOff: 3.7,
    trans: true,
    noHead: true,
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
  {
    name: "Spooky",
    limT: "Raid",
    id: 0,
    tex: 8,
    rarity: 3,
    type: 7,
    keyW: "Face",
    seas: 4,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
  {
    name: "Rune Lord",
    limT: "Raid",
    keyW: "Back",
    id: 69,
    glow: true,
    type: 2,
    scl: 2.3,
    sclMlt: 0.8,
    sitOff: -1.1,
    sitOffZ: -2,
    yOff: -0.9,
    xOff: -0.3,
    rarity: 5,
    seas: 4,
    color: 4235601,
    rAnim: -0.002,
    rAnimA: "x",
    noSale: true,
    noSpin: true,
    trans: true,
    emiss: 11075511,
    side: 2,
    noQuickSell: true,
  },
  {
    name: "Ghostly",
    limT: "Raid",
    noSale: true,
    noSpin: true,
    id: 12,
    sameGlow: true,
    opac: 0.9,
    emiss: 11075511,
    color: 3823936,
    seas: 4,
    type: 5,
    rarity: 5,
    noQuickSell: true,
  },
  {
    name: "Skelly",
    limT: "Raid",
    noSpin: true,
    noSale: true,
    rarity: 2,
    seas: 4,
    id: 99,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
    noQuickSell: true,
  },
  {
    name: "Halloween",
    limT: "Raid",
    noSpin: true,
    noSale: true,
    rarity: 2,
    seas: 4,
    id: 100,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
    noQuickSell: true,
  },
  {
    name: "Ghostly Cowboy",
    limT: "Raid",
    noSale: true,
    noSpin: true,
    type: 1,
    keyW: "Head",
    scl: 2.5,
    sitOff: 0.4,
    glow: true,
    emiss: 11075511,
    yOff: -3,
    tex: 1,
    id: 0,
    seas: 4,
    rarity: 3,
    noQuickSell: true,
    opac: 0.9,
  },
  {
    name: "Grinner",
    limT: "Raid",
    id: 0,
    tex: 9,
    rarity: 3,
    type: 7,
    keyW: "Face",
    seas: 4,
    sitOff: 1,
    sitOffZ: 0.005,
    trans: true,
    yOff: -0.7,
    xOff: 1.6,
    xRot: -0.5,
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
  {
    name: "Bats",
    limT: "Raid",
    rarity: 2,
    seas: 4,
    id: 102,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
  {
    name: "Ectoplasm",
    limT: "Raid",
    glow: true,
    opac: 0.9,
    color: 3823936,
    id: 0,
    weapon: 3,
    rarity: 4,
    seas: 4,
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
  {
    name: "Devil Horns",
    limT: "Raid",
    id: 115,
    tex: 1,
    rarity: 3,
    type: 1,
    keyW: "Hat",
    scl: 1,
    sclMlt: 0.45,
    sitOff: 0.4,
    yOff: -0.7,
    xOff: 0.2,
    seas: 4,
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
  {
    name: "Devious",
    keyW: "Waist",
    limT: "Raid",
    rarity: 4,
    seas: 4,
    id: 12,
    type: 6,
    scl: 2.1,
    spnScl: 3,
    sclMlt: 0.6,
    sitOff: 0.9,
    sitOffZ: 0.4,
    prevRot: 2,
    xOff: -2,
    noSpin: true,
    noQuickSell: true,
    noSale: true,
  },
  {
    name: "Necromancer",
    limT: "Raid",
    rarity: 4,
    id: 142,
    glow: true,
    tex: 1,
    type: 1,
    color: 3823936,
    opac: 0.9,
    sclMlt: 0.5,
    sitOff: 1,
    yOff: -2,
    keyW: "Hat",
    seas: 4,
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
  {
    name: "OMEGASOUL",
    limT: "Raid",
    rarity: 2,
    seas: 4,
    id: 103,
    type: 4,
    opacity: 0.9,
    keyW: "Sprays",
    noSale: true,
    noSpin: true,
    noQuickSell: true,
  },
];
for (var c = 0; c < module.exports.skins.length; c++) {
  module.exports.skins[c].index = c;
}
